import React from 'react';
import './styles/illustration-saga.css';

// tslint:disable: max-line-length
interface Props {
  width?: number;
  color1?: string;
  color2?: string;
}
function IllustrationSagaSvg(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="470.417"
      viewBox="0 0 470.417 297.4"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="1.792"
          y1="-0.332"
          x2="0.086"
          y2="0.802"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#ebeef7" />
          <stop offset="1" stopColor="#9297a5" />
        </linearGradient>
        <clipPath id="clip-path">
          <path
            id="Tracé_2"
            data-name="Tracé 2"
            d="M457.4,132.9c5.1-.9,8.6,4.4,9.6,9.1.5,2.5.5,5.4,2.5,7.1a15.569,15.569,0,0,0,2.8,1.6c5.6,2.9,6,8.3,6.1,13.8a5.025,5.025,0,0,0,.5,2.7c.5.9,1.5,1.4,2.1,2.3a4.793,4.793,0,0,1,.7,2c1.4,6.2.7,11.9.6,18.1-.3,44.1-24.3,42-24.3,42h-.9c-5.8-.3-11-3.9-14.5-8.4-3.5-4.6-5.5-10.3-6.7-16a89.834,89.834,0,0,1-1.5-12.7c-.3-4.6-1.2-8.9.6-13.3.8-2,2.1-4,2.1-6.2,0-2.4-1.5-4.6-1.6-7a12.667,12.667,0,0,1,.9-4.2,66.546,66.546,0,0,1,4.4-9.8c1.4-2.4,4.5-3.7,5.3-6.4a12.968,12.968,0,0,0,.2-3.4c.2-5.6,5.1-9.6,10.1-11A4.283,4.283,0,0,1,457.4,132.9Z"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-2"
          x1="0.059"
          y1="0.308"
          x2="1.704"
          y2="1.118"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor={props.color2 ? props.color2 : '#ffa1a1'} />
          <stop offset="1" stopColor={props.color1 ? props.color1 : '#ff4137'} />
        </linearGradient>
        <clipPath id="clip-path-2">
          <path
            id="Tracé_4"
            data-name="Tracé 4"
            d="M411.2,98.5c6.3-1.1,10.7,5.5,12,11.3.7,3.1.7,6.7,3.1,8.8a14.789,14.789,0,0,0,3.5,1.9c7,3.6,7.4,10.3,7.6,17.1a7.451,7.451,0,0,0,.6,3.3c.7,1.1,1.9,1.7,2.6,2.8a6.989,6.989,0,0,1,.9,2.4c1.8,7.7.8,14.7.8,22.4-.4,54.6-30.1,52-30.1,52H411c-7.2-.3-13.7-4.8-17.9-10.3-4.4-5.7-6.8-12.8-8.3-19.8a103.4,103.4,0,0,1-1.8-15.7c-.3-5.7-1.5-11,.7-16.5,1-2.5,2.6-5,2.6-7.7,0-3-1.8-5.7-1.9-8.7a11.986,11.986,0,0,1,1.2-5.2,87.45,87.45,0,0,1,5.4-12.1c1.7-2.9,5.6-4.6,6.6-8a19.8,19.8,0,0,0,.3-4.2c.2-7,6.3-11.9,12.6-13.6C410.6,98.6,410.9,98.6,411.2,98.5Z"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-3"
          x1="0.896"
          y1="0.684"
          x2="-0.664"
          y2="0.031"
          xlinkHref="#linear-gradient-2"
        />
        <clipPath id="clip-path-3">
          <path
            id="Tracé_6"
            data-name="Tracé 6"
            d="M56.6,105.5c6.3-1.1,10.7,5.5,12,11.3.7,3.1.7,6.7,3.1,8.8a14.79,14.79,0,0,0,3.5,1.9c7,3.6,7.4,10.3,7.6,17.1a7.451,7.451,0,0,0,.6,3.3c.7,1.1,1.9,1.7,2.6,2.8a6.989,6.989,0,0,1,.9,2.4c1.8,7.7.8,14.7.8,22.4-.4,54.6-30.1,52-30.1,52H56.4c-7.2-.3-13.7-4.8-17.9-10.3-4.4-5.7-6.8-12.8-8.3-19.8a103.407,103.407,0,0,1-1.8-15.7c-.3-5.7-1.5-11,.7-16.5,1-2.5,2.6-5,2.6-7.7,0-3-1.8-5.7-1.9-8.7a11.986,11.986,0,0,1,1.2-5.2,87.451,87.451,0,0,1,5.4-12.1c1.7-2.9,5.6-4.6,6.6-8a19.806,19.806,0,0,0,.3-4.2c.2-7,6.3-11.9,12.6-13.6A6.371,6.371,0,0,1,56.6,105.5Z"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-4"
          x1="0.907"
          y1="0.051"
          x2="0.163"
          y2="1.363"
          xlinkHref="#linear-gradient"
        />
      </defs>
      <g id="Calque_4" transform="translate(-12.146 -12.2)">
        <g id="fond_gradient_1_" opacity="0.5">
          <path
            id="XMLID_507_"
            d="M408.5,289.7c-146.2,3.3-344.2-4.4-344.2,0C50.1,277.3,41.8,257.3,46,240c4.1-17.3-25.3-38.8-19.1-73,5.3-28.9,36.4-43.5,50.5-77,9.3-22.2,43.4-52.8,78.1-36,20.5,9.9,20.9,24.5,45.7,33,18.4,6.3,38.2-13.2,63.5-43.8,23.1-27.9,81.7-41.7,116-6.5,40.6,41.6,12.9,77.9,54.8,106.3C469,165.6,437,262.4,408.5,289.7Z"
            fill="#c3cae5"
            fill-rule="evenodd"
          />
        </g>
        <g id="XMLID_2115_">
          <path id="XMLID_1994_" d="M97.4,159.8V268H147V159.8H97.4Z" fill="#e2e5ed" />
          <path id="XMLID_1993_" d="M361.3,172.6H344.9V149.8h-41V268H402V172.6Z" fill="#e2e5ed" />
          <path
            id="XMLID_1992_"
            d="M285.3,96.7a4.8,4.8,0,0,0-4.8-4.8H235.9a4.387,4.387,0,0,0-3.1,1.3,4.909,4.909,0,0,0-1.5,3.5v7.4H220.8v35h-56V268H295.9V104.1H285.4V96.7Z"
            fill="#e2e5ed"
          />
          <g id="XMLID_9150_">
            <rect id="XMLID_9321_" width="57.2" height="124.9" transform="translate(111.1 108.2)" fill="#e2e5ed" />
            <rect id="XMLID_9320_" width="17.8" height="124.9" transform="translate(111.1 108.2)" fill="#e2e5ed" />
            <g id="XMLID_9309_">
              <rect id="XMLID_9319_" width="2.6" height="3.6" transform="translate(162 114.1)" fill="#fff" />
              <rect id="XMLID_9318_" width="2.6" height="3.6" transform="translate(157.2 114.1)" fill="#fff" />
              <rect id="XMLID_9317_" width="2.6" height="3.6" transform="translate(152.4 114.1)" fill="#fff" />
              <rect id="XMLID_9316_" width="2.6" height="3.6" transform="translate(147.6 114.1)" fill="#fff" />
              <rect id="XMLID_9315_" width="2.6" height="3.6" transform="translate(142.8 114.1)" fill="#fff" />
              <rect id="XMLID_9314_" width="2.6" height="3.6" transform="translate(138 114.1)" fill="#fff" />
              <rect id="XMLID_9313_" width="2.6" height="3.6" transform="translate(133.2 114.1)" fill="#fff" />
              <rect id="XMLID_9312_" width="2.6" height="3.6" transform="translate(124.4 114.1)" fill="#fff" />
              <rect id="XMLID_9311_" width="2.6" height="3.6" transform="translate(119.6 114.1)" fill="#fff" />
              <rect id="XMLID_9310_" width="2.6" height="3.6" transform="translate(114.8 114.1)" fill="#fff" />
            </g>
            <g id="XMLID_9298_">
              <rect id="XMLID_9308_" width="2.6" height="3.6" transform="translate(162 121.6)" fill="#fff" />
              <rect id="XMLID_9307_" width="2.6" height="3.6" transform="translate(157.2 121.6)" fill="#fff" />
              <rect id="XMLID_9306_" width="2.6" height="3.6" transform="translate(152.4 121.6)" fill="#fff" />
              <rect id="XMLID_9305_" width="2.6" height="3.6" transform="translate(147.6 121.6)" fill="#fff" />
              <rect id="XMLID_9304_" width="2.6" height="3.6" transform="translate(142.8 121.6)" fill="#fff" />
              <rect id="XMLID_9303_" width="2.6" height="3.6" transform="translate(138 121.6)" fill="#fff" />
              <rect id="XMLID_9302_" width="2.6" height="3.6" transform="translate(133.2 121.6)" fill="#fff" />
              <rect id="XMLID_9301_" width="2.6" height="3.6" transform="translate(124.4 121.6)" fill="#fff" />
              <rect id="XMLID_9300_" width="2.6" height="3.6" transform="translate(119.6 121.6)" fill="#fff" />
              <rect id="XMLID_9299_" width="2.6" height="3.6" transform="translate(114.8 121.6)" fill="#fff" />
            </g>
            <g id="XMLID_9286_">
              <rect id="XMLID_9297_" width="2.6" height="3.6" transform="translate(162 129.2)" fill="#fff" />
              <rect id="XMLID_9296_" width="2.6" height="3.6" transform="translate(157.2 129.2)" fill="#fff" />
              <rect id="XMLID_9294_" width="2.6" height="3.6" transform="translate(152.4 129.2)" fill="#fff" />
              <rect id="XMLID_9293_" width="2.6" height="3.6" transform="translate(147.6 129.2)" fill="#fff" />
              <rect id="XMLID_9292_" width="2.6" height="3.6" transform="translate(142.8 129.2)" fill="#fff" />
              <rect id="XMLID_9291_" width="2.6" height="3.6" transform="translate(138 129.2)" fill="#fff" />
              <rect id="XMLID_9290_" width="2.6" height="3.6" transform="translate(133.2 129.2)" fill="#fff" />
              <rect id="XMLID_9289_" width="2.6" height="3.6" transform="translate(124.4 129.2)" fill="#fff" />
              <rect id="XMLID_9288_" width="2.6" height="3.6" transform="translate(119.6 129.2)" fill="#fff" />
              <rect id="XMLID_9287_" width="2.6" height="3.6" transform="translate(114.8 129.2)" fill="#fff" />
            </g>
            <g id="XMLID_9275_">
              <rect id="XMLID_9285_" width="2.6" height="3.6" transform="translate(162 136.7)" fill="#fff" />
              <rect id="XMLID_9284_" width="2.6" height="3.6" transform="translate(157.2 136.7)" fill="#fff" />
              <rect id="XMLID_9283_" width="2.6" height="3.6" transform="translate(152.4 136.7)" fill="#fff" />
              <rect id="XMLID_9282_" width="2.6" height="3.6" transform="translate(147.6 136.7)" fill="#fff" />
              <rect id="XMLID_9281_" width="2.6" height="3.6" transform="translate(142.8 136.7)" fill="#fff" />
              <rect id="XMLID_9280_" width="2.6" height="3.6" transform="translate(138 136.7)" fill="#fff" />
              <rect id="XMLID_9279_" width="2.6" height="3.6" transform="translate(133.2 136.7)" fill="#fff" />
              <rect id="XMLID_9278_" width="2.6" height="3.6" transform="translate(124.4 136.7)" fill="#fff" />
              <rect id="XMLID_9277_" width="2.6" height="3.6" transform="translate(119.6 136.7)" fill="#fff" />
              <rect id="XMLID_9276_" width="2.6" height="3.6" transform="translate(114.8 136.7)" fill="#fff" />
            </g>
            <g id="XMLID_9264_">
              <rect id="XMLID_9274_" width="2.6" height="3.6" transform="translate(162 144.2)" fill="#fff" />
              <rect id="XMLID_9273_" width="2.6" height="3.6" transform="translate(157.2 144.2)" fill="#fff" />
              <rect id="XMLID_9272_" width="2.6" height="3.6" transform="translate(152.4 144.2)" fill="#fff" />
              <rect id="XMLID_9271_" width="2.6" height="3.6" transform="translate(147.6 144.2)" fill="#fff" />
              <rect id="XMLID_9270_" width="2.6" height="3.6" transform="translate(142.8 144.2)" fill="#fff" />
              <rect id="XMLID_9269_" width="2.6" height="3.6" transform="translate(138 144.2)" fill="#fff" />
              <rect id="XMLID_9268_" width="2.6" height="3.6" transform="translate(133.2 144.2)" fill="#fff" />
              <rect id="XMLID_9267_" width="2.6" height="3.6" transform="translate(124.4 144.2)" fill="#fff" />
              <rect id="XMLID_9266_" width="2.6" height="3.6" transform="translate(119.6 144.2)" fill="#fff" />
              <rect id="XMLID_9265_" width="2.6" height="3.6" transform="translate(114.8 144.2)" fill="#fff" />
            </g>
            <g id="XMLID_9252_">
              <rect id="XMLID_9263_" width="2.6" height="3.6" transform="translate(162 151.8)" fill="#fff" />
              <rect id="XMLID_9262_" width="2.6" height="3.6" transform="translate(157.2 151.8)" fill="#fff" />
              <rect id="XMLID_9261_" width="2.6" height="3.6" transform="translate(152.4 151.8)" fill="#fff" />
              <rect id="XMLID_9260_" width="2.6" height="3.6" transform="translate(147.6 151.8)" fill="#fff" />
              <rect id="XMLID_9259_" width="2.6" height="3.6" transform="translate(142.8 151.8)" fill="#fff" />
              <rect id="XMLID_9258_" width="2.6" height="3.6" transform="translate(138 151.8)" fill="#fff" />
              <rect id="XMLID_9257_" width="2.6" height="3.6" transform="translate(133.2 151.8)" fill="#fff" />
              <rect id="XMLID_9255_" width="2.6" height="3.6" transform="translate(124.4 151.8)" fill="#fff" />
              <rect id="XMLID_9254_" width="2.6" height="3.6" transform="translate(119.6 151.8)" fill="#fff" />
              <rect id="XMLID_9253_" width="2.6" height="3.6" transform="translate(114.8 151.8)" fill="#fff" />
            </g>
            <g id="XMLID_9241_">
              <rect id="XMLID_9251_" width="2.6" height="3.6" transform="translate(162 159.3)" fill="#fff" />
              <rect id="XMLID_9250_" width="2.6" height="3.6" transform="translate(157.2 159.3)" fill="#fff" />
              <rect id="XMLID_9249_" width="2.6" height="3.6" transform="translate(152.4 159.3)" fill="#fff" />
              <rect id="XMLID_9248_" width="2.6" height="3.6" transform="translate(147.6 159.3)" fill="#fff" />
              <rect id="XMLID_9247_" width="2.6" height="3.6" transform="translate(142.8 159.3)" fill="#fff" />
              <rect id="XMLID_9246_" width="2.6" height="3.6" transform="translate(138 159.3)" fill="#fff" />
              <rect id="XMLID_9245_" width="2.6" height="3.6" transform="translate(133.2 159.3)" fill="#fff" />
              <rect id="XMLID_9244_" width="2.6" height="3.6" transform="translate(124.4 159.3)" fill="#fff" />
              <rect id="XMLID_9243_" width="2.6" height="3.6" transform="translate(119.6 159.3)" fill="#fff" />
              <rect id="XMLID_9242_" width="2.6" height="3.6" transform="translate(114.8 159.3)" fill="#fff" />
            </g>
            <g id="XMLID_9230_">
              <rect id="XMLID_9240_" width="2.6" height="3.6" transform="translate(162 166.8)" fill="#fff" />
              <rect id="XMLID_9239_" width="2.6" height="3.6" transform="translate(157.2 166.8)" fill="#fff" />
              <rect id="XMLID_9238_" width="2.6" height="3.6" transform="translate(152.4 166.8)" fill="#fff" />
              <rect id="XMLID_9237_" width="2.6" height="3.6" transform="translate(147.6 166.8)" fill="#fff" />
              <rect id="XMLID_9236_" width="2.6" height="3.6" transform="translate(142.8 166.8)" fill="#fff" />
              <rect id="XMLID_9235_" width="2.6" height="3.6" transform="translate(138 166.8)" fill="#fff" />
              <rect id="XMLID_9234_" width="2.6" height="3.6" transform="translate(133.2 166.8)" fill="#fff" />
              <rect id="XMLID_9233_" width="2.6" height="3.6" transform="translate(124.4 166.8)" fill="#fff" />
              <rect id="XMLID_9232_" width="2.6" height="3.6" transform="translate(119.6 166.8)" fill="#fff" />
              <rect id="XMLID_9231_" width="2.6" height="3.6" transform="translate(114.8 166.8)" fill="#fff" />
            </g>
            <g id="XMLID_9219_">
              <rect id="XMLID_9229_" width="2.6" height="3.6" transform="translate(162 174.3)" fill="#fff" />
              <rect id="XMLID_9228_" width="2.6" height="3.6" transform="translate(157.2 174.3)" fill="#fff" />
              <rect id="XMLID_9227_" width="2.6" height="3.6" transform="translate(152.4 174.3)" fill="#fff" />
              <rect id="XMLID_9226_" width="2.6" height="3.6" transform="translate(147.6 174.3)" fill="#fff" />
              <rect id="XMLID_9225_" width="2.6" height="3.6" transform="translate(142.8 174.3)" fill="#fff" />
              <rect id="XMLID_9224_" width="2.6" height="3.6" transform="translate(138 174.3)" fill="#fff" />
              <rect id="XMLID_9223_" width="2.6" height="3.6" transform="translate(133.2 174.3)" fill="#fff" />
              <rect id="XMLID_9222_" width="2.6" height="3.6" transform="translate(124.4 174.3)" fill="#fff" />
              <rect id="XMLID_9221_" width="2.6" height="3.6" transform="translate(119.6 174.3)" fill="#fff" />
              <rect id="XMLID_9220_" width="2.6" height="3.6" transform="translate(114.8 174.3)" fill="#fff" />
            </g>
            <g id="XMLID_9207_">
              <rect id="XMLID_9218_" width="2.6" height="3.6" transform="translate(162 181.9)" fill="#fff" />
              <rect id="XMLID_9216_" width="2.6" height="3.6" transform="translate(157.2 181.9)" fill="#fff" />
              <rect id="XMLID_9215_" width="2.6" height="3.6" transform="translate(152.4 181.9)" fill="#fff" />
              <rect id="XMLID_9214_" width="2.6" height="3.6" transform="translate(147.6 181.9)" fill="#fff" />
              <rect id="XMLID_9213_" width="2.6" height="3.6" transform="translate(142.8 181.9)" fill="#fff" />
              <rect id="XMLID_9212_" width="2.6" height="3.6" transform="translate(138 181.9)" fill="#fff" />
              <rect id="XMLID_9211_" width="2.6" height="3.6" transform="translate(133.2 181.9)" fill="#fff" />
              <rect id="XMLID_9210_" width="2.6" height="3.6" transform="translate(124.4 181.9)" fill="#fff" />
              <rect id="XMLID_9209_" width="2.6" height="3.6" transform="translate(119.6 181.9)" fill="#fff" />
              <rect id="XMLID_9208_" width="2.6" height="3.6" transform="translate(114.8 181.9)" fill="#fff" />
            </g>
            <g id="XMLID_9196_">
              <rect id="XMLID_9206_" width="2.6" height="3.6" transform="translate(162 189.4)" fill="#fff" />
              <rect id="XMLID_9205_" width="2.6" height="3.6" transform="translate(157.2 189.4)" fill="#fff" />
              <rect id="XMLID_9204_" width="2.6" height="3.6" transform="translate(152.4 189.4)" fill="#fff" />
              <rect id="XMLID_9203_" width="2.6" height="3.6" transform="translate(147.6 189.4)" fill="#fff" />
              <rect id="XMLID_9202_" width="2.6" height="3.6" transform="translate(142.8 189.4)" fill="#fff" />
              <rect id="XMLID_9201_" width="2.6" height="3.6" transform="translate(138 189.4)" fill="#fff" />
              <rect id="XMLID_9200_" width="2.6" height="3.6" transform="translate(133.2 189.4)" fill="#fff" />
              <rect id="XMLID_9199_" width="2.6" height="3.6" transform="translate(124.4 189.4)" fill="#fff" />
              <rect id="XMLID_9198_" width="2.6" height="3.6" transform="translate(119.6 189.4)" fill="#fff" />
              <rect id="XMLID_9197_" width="2.6" height="3.6" transform="translate(114.8 189.4)" fill="#fff" />
            </g>
            <g id="XMLID_9185_">
              <rect id="XMLID_9195_" width="2.6" height="3.6" transform="translate(162 196.9)" fill="#fff" />
              <rect id="XMLID_9194_" width="2.6" height="3.6" transform="translate(157.2 196.9)" fill="#fff" />
              <rect id="XMLID_9193_" width="2.6" height="3.6" transform="translate(152.4 196.9)" fill="#fff" />
              <rect id="XMLID_9192_" width="2.6" height="3.6" transform="translate(147.6 196.9)" fill="#fff" />
              <rect id="XMLID_9191_" width="2.6" height="3.6" transform="translate(142.8 196.9)" fill="#fff" />
              <rect id="XMLID_9190_" width="2.6" height="3.6" transform="translate(138 196.9)" fill="#fff" />
              <rect id="XMLID_9189_" width="2.6" height="3.6" transform="translate(133.2 196.9)" fill="#fff" />
              <rect id="XMLID_9188_" width="2.6" height="3.6" transform="translate(124.4 196.9)" fill="#fff" />
              <rect id="XMLID_9187_" width="2.6" height="3.6" transform="translate(119.6 196.9)" fill="#fff" />
              <rect id="XMLID_9186_" width="2.6" height="3.6" transform="translate(114.8 196.9)" fill="#fff" />
            </g>
            <g id="XMLID_9173_">
              <rect id="XMLID_9184_" width="2.6" height="3.6" transform="translate(162 204.5)" fill="#fff" />
              <rect id="XMLID_9183_" width="2.6" height="3.6" transform="translate(157.2 204.5)" fill="#fff" />
              <rect id="XMLID_9182_" width="2.6" height="3.6" transform="translate(152.4 204.5)" fill="#fff" />
              <rect id="XMLID_9181_" width="2.6" height="3.6" transform="translate(147.6 204.5)" fill="#fff" />
              <rect id="XMLID_9180_" width="2.6" height="3.6" transform="translate(142.8 204.5)" fill="#fff" />
              <rect id="XMLID_9179_" width="2.6" height="3.6" transform="translate(138 204.5)" fill="#fff" />
              <rect id="XMLID_9177_" width="2.6" height="3.6" transform="translate(133.2 204.5)" fill="#fff" />
              <rect id="XMLID_9176_" width="2.6" height="3.6" transform="translate(124.4 204.5)" fill="#fff" />
              <rect id="XMLID_9175_" width="2.6" height="3.6" transform="translate(119.6 204.5)" fill="#fff" />
              <rect id="XMLID_9174_" width="2.6" height="3.6" transform="translate(114.8 204.5)" fill="#fff" />
            </g>
            <g id="XMLID_9162_">
              <rect id="XMLID_9172_" width="2.6" height="3.6" transform="translate(162 212)" fill="#fff" />
              <rect id="XMLID_9171_" width="2.6" height="3.6" transform="translate(157.2 212)" fill="#fff" />
              <rect id="XMLID_9170_" width="2.6" height="3.6" transform="translate(152.4 212)" fill="#fff" />
              <rect id="XMLID_9169_" width="2.6" height="3.6" transform="translate(147.6 212)" fill="#fff" />
              <rect id="XMLID_9168_" width="2.6" height="3.6" transform="translate(142.8 212)" fill="#fff" />
              <rect id="XMLID_9167_" width="2.6" height="3.6" transform="translate(138 212)" fill="#fff" />
              <rect id="XMLID_9166_" width="2.6" height="3.6" transform="translate(133.2 212)" fill="#fff" />
              <rect id="XMLID_9165_" width="2.6" height="3.6" transform="translate(124.4 212)" fill="#fff" />
              <rect id="XMLID_9164_" width="2.6" height="3.6" transform="translate(119.6 212)" fill="#fff" />
              <rect id="XMLID_9163_" width="2.6" height="3.6" transform="translate(114.8 212)" fill="#fff" />
            </g>
            <g id="XMLID_9151_">
              <rect id="XMLID_9161_" width="2.6" height="3.6" transform="translate(162 219.5)" fill="#fff" />
              <rect id="XMLID_9160_" width="2.6" height="3.6" transform="translate(157.2 219.5)" fill="#fff" />
              <rect id="XMLID_9159_" width="2.6" height="3.6" transform="translate(152.4 219.5)" fill="#fff" />
              <rect id="XMLID_9158_" width="2.6" height="3.6" transform="translate(147.6 219.5)" fill="#fff" />
              <rect id="XMLID_9157_" width="2.6" height="3.6" transform="translate(142.8 219.5)" fill="#fff" />
              <rect id="XMLID_9156_" width="2.6" height="3.6" transform="translate(138 219.5)" fill="#fff" />
              <rect id="XMLID_9155_" width="2.6" height="3.6" transform="translate(133.2 219.5)" fill="#fff" />
              <rect id="XMLID_9154_" width="2.6" height="3.6" transform="translate(124.4 219.5)" fill="#fff" />
              <rect id="XMLID_9153_" width="2.6" height="3.6" transform="translate(119.6 219.5)" fill="#fff" />
              <rect id="XMLID_9152_" width="2.6" height="3.6" transform="translate(114.8 219.5)" fill="#fff" />
            </g>
          </g>
          <g id="XMLID_9118_">
            <rect id="XMLID_9149_" width="44.3" height="127.8" transform="translate(240.4 100.4)" fill="#e2e5ed" />
            <rect id="XMLID_9148_" width="13.8" height="127.8" transform="translate(240.4 100.4)" fill="#e2e5ed" />
            <g id="XMLID_9146_">
              <rect id="XMLID_9147_" width="44.3" height="1.1" transform="translate(240.4 107.4)" fill="#fff" />
            </g>
            <g id="XMLID_9144_">
              <rect id="XMLID_9145_" width="44.3" height="1.1" transform="translate(240.4 115.8)" fill="#fff" />
            </g>
            <g id="XMLID_9142_">
              <rect id="XMLID_9143_" width="44.3" height="1.1" transform="translate(240.4 124.3)" fill="#fff" />
            </g>
            <g id="XMLID_9140_">
              <rect id="XMLID_9141_" width="44.3" height="1.1" transform="translate(240.4 132.7)" fill="#fff" />
            </g>
            <g id="XMLID_9137_">
              <rect id="XMLID_9138_" width="44.3" height="1.1" transform="translate(240.4 141.1)" fill="#fff" />
            </g>
            <g id="XMLID_9135_">
              <rect id="XMLID_9136_" width="44.3" height="1.1" transform="translate(240.4 149.6)" fill="#fff" />
            </g>
            <g id="XMLID_9133_">
              <rect id="XMLID_9134_" width="44.3" height="1.1" transform="translate(240.4 158)" fill="#fff" />
            </g>
            <g id="XMLID_9131_">
              <rect id="XMLID_9132_" width="44.3" height="1.1" transform="translate(240.4 166.4)" fill="#fff" />
            </g>
            <g id="XMLID_9129_">
              <rect id="XMLID_9130_" width="44.3" height="1.1" transform="translate(240.4 174.9)" fill="#fff" />
            </g>
            <g id="XMLID_9127_">
              <rect id="XMLID_9128_" width="44.3" height="1.1" transform="translate(240.4 183.3)" fill="#fff" />
            </g>
            <g id="XMLID_9125_">
              <rect id="XMLID_9126_" width="44.3" height="1.1" transform="translate(240.4 191.7)" fill="#fff" />
            </g>
            <g id="XMLID_9123_">
              <rect id="XMLID_9124_" width="44.3" height="1.1" transform="translate(240.4 200.2)" fill="#fff" />
            </g>
            <g id="XMLID_9121_">
              <rect id="XMLID_9122_" width="44.3" height="1.1" transform="translate(240.4 208.6)" fill="#fff" />
            </g>
            <g id="XMLID_9119_">
              <rect id="XMLID_9120_" width="44.3" height="1.1" transform="translate(240.4 217.1)" fill="#fff" />
            </g>
          </g>
          <g id="XMLID_8938_">
            <g id="XMLID_8946_">
              <rect id="XMLID_9117_" width="81.2" height="177.2" transform="translate(284.1 50.1)" fill="#e2e5ed" />
              <rect id="XMLID_9116_" width="25.3" height="177.2" transform="translate(284.1 50.1)" fill="#e2e5ed" />
              <g id="XMLID_9105_">
                <rect id="XMLID_9115_" width="3.7" height="5.1" transform="translate(356.3 58.5)" fill="#fff" />
                <rect id="XMLID_9114_" width="3.7" height="5.1" transform="translate(349.5 58.5)" fill="#fff" />
                <rect id="XMLID_9113_" width="3.7" height="5.1" transform="translate(342.7 58.5)" fill="#fff" />
                <rect id="XMLID_9112_" width="3.7" height="5.1" transform="translate(335.9 58.5)" fill="#fff" />
                <rect id="XMLID_9111_" width="3.7" height="5.1" transform="translate(329 58.5)" fill="#fff" />
                <rect id="XMLID_9110_" width="3.7" height="5.1" transform="translate(322.2 58.5)" fill="#fff" />
                <rect id="XMLID_9109_" width="3.7" height="5.1" transform="translate(315.4 58.5)" fill="#fff" />
                <rect id="XMLID_9108_" width="3.7" height="5.1" transform="translate(302.9 58.5)" fill="#fff" />
                <rect id="XMLID_9107_" width="3.7" height="5.1" transform="translate(296.1 58.5)" fill="#fff" />
                <rect id="XMLID_9106_" width="3.7" height="5.1" transform="translate(289.3 58.5)" fill="#fff" />
              </g>
              <g id="XMLID_9093_">
                <rect id="XMLID_9104_" width="3.7" height="5.1" transform="translate(356.3 69.2)" fill="#fff" />
                <rect id="XMLID_9103_" width="3.7" height="5.1" transform="translate(349.5 69.2)" fill="#fff" />
                <rect id="XMLID_9102_" width="3.7" height="5.1" transform="translate(342.7 69.2)" fill="#fff" />
                <rect id="XMLID_9101_" width="3.7" height="5.1" transform="translate(335.9 69.2)" fill="#fff" />
                <rect id="XMLID_9099_" width="3.7" height="5.1" transform="translate(329 69.2)" fill="#fff" />
                <rect id="XMLID_9098_" width="3.7" height="5.1" transform="translate(322.2 69.2)" fill="#fff" />
                <rect id="XMLID_9097_" width="3.7" height="5.1" transform="translate(315.4 69.2)" fill="#fff" />
                <rect id="XMLID_9096_" width="3.7" height="5.1" transform="translate(302.9 69.2)" fill="#fff" />
                <rect id="XMLID_9095_" width="3.7" height="5.1" transform="translate(296.1 69.2)" fill="#fff" />
                <rect id="XMLID_9094_" width="3.7" height="5.1" transform="translate(289.3 69.2)" fill="#fff" />
              </g>
              <g id="XMLID_9082_">
                <rect id="XMLID_9092_" width="3.7" height="5.1" transform="translate(356.3 79.9)" fill="#fff" />
                <rect id="XMLID_9091_" width="3.7" height="5.1" transform="translate(349.5 79.9)" fill="#fff" />
                <rect id="XMLID_9090_" width="3.7" height="5.1" transform="translate(342.7 79.9)" fill="#fff" />
                <rect id="XMLID_9089_" width="3.7" height="5.1" transform="translate(335.9 79.9)" fill="#fff" />
                <rect id="XMLID_9088_" width="3.7" height="5.1" transform="translate(329 79.9)" fill="#fff" />
                <rect id="XMLID_9087_" width="3.7" height="5.1" transform="translate(322.2 79.9)" fill="#fff" />
                <rect id="XMLID_9086_" width="3.7" height="5.1" transform="translate(315.4 79.9)" fill="#fff" />
                <rect id="XMLID_9085_" width="3.7" height="5.1" transform="translate(302.9 79.9)" fill="#fff" />
                <rect id="XMLID_9084_" width="3.7" height="5.1" transform="translate(296.1 79.9)" fill="#fff" />
                <rect id="XMLID_9083_" width="3.7" height="5.1" transform="translate(289.3 79.9)" fill="#fff" />
              </g>
              <g id="XMLID_9071_">
                <rect id="XMLID_9081_" width="3.7" height="5.1" transform="translate(356.3 90.6)" fill="#fff" />
                <rect id="XMLID_9080_" width="3.7" height="5.1" transform="translate(349.5 90.6)" fill="#fff" />
                <rect id="XMLID_9079_" width="3.7" height="5.1" transform="translate(342.7 90.6)" fill="#fff" />
                <rect id="XMLID_9078_" width="3.7" height="5.1" transform="translate(335.9 90.6)" fill="#fff" />
                <rect id="XMLID_9077_" width="3.7" height="5.1" transform="translate(329 90.6)" fill="#fff" />
                <rect id="XMLID_9076_" width="3.7" height="5.1" transform="translate(322.2 90.6)" fill="#fff" />
                <rect id="XMLID_9075_" width="3.7" height="5.1" transform="translate(315.4 90.6)" fill="#fff" />
                <rect id="XMLID_9074_" width="3.7" height="5.1" transform="translate(302.9 90.6)" fill="#fff" />
                <rect id="XMLID_9073_" width="3.7" height="5.1" transform="translate(296.1 90.6)" fill="#fff" />
                <rect id="XMLID_9072_" width="3.7" height="5.1" transform="translate(289.3 90.6)" fill="#fff" />
              </g>
              <g id="XMLID_9059_">
                <rect id="XMLID_9070_" width="3.7" height="5.1" transform="translate(356.3 101.2)" fill="#fff" />
                <rect id="XMLID_9069_" width="3.7" height="5.1" transform="translate(349.5 101.2)" fill="#fff" />
                <rect id="XMLID_9068_" width="3.7" height="5.1" transform="translate(342.7 101.2)" fill="#fff" />
                <rect id="XMLID_9067_" width="3.7" height="5.1" transform="translate(335.9 101.2)" fill="#fff" />
                <rect id="XMLID_9066_" width="3.7" height="5.1" transform="translate(329 101.2)" fill="#fff" />
                <rect id="XMLID_9065_" width="3.7" height="5.1" transform="translate(322.2 101.2)" fill="#fff" />
                <rect id="XMLID_9064_" width="3.7" height="5.1" transform="translate(315.4 101.2)" fill="#fff" />
                <rect id="XMLID_9063_" width="3.7" height="5.1" transform="translate(302.9 101.2)" fill="#fff" />
                <rect id="XMLID_9062_" width="3.7" height="5.1" transform="translate(296.1 101.2)" fill="#fff" />
                <rect id="XMLID_9060_" width="3.7" height="5.1" transform="translate(289.3 101.2)" fill="#fff" />
              </g>
              <g id="XMLID_9048_">
                <rect id="XMLID_9058_" width="3.7" height="5.1" transform="translate(356.3 111.9)" fill="#fff" />
                <rect id="XMLID_9057_" width="3.7" height="5.1" transform="translate(349.5 111.9)" fill="#fff" />
                <rect id="XMLID_9056_" width="3.7" height="5.1" transform="translate(342.7 111.9)" fill="#fff" />
                <rect id="XMLID_9055_" width="3.7" height="5.1" transform="translate(335.9 111.9)" fill="#fff" />
                <rect id="XMLID_9054_" width="3.7" height="5.1" transform="translate(329 111.9)" fill="#fff" />
                <rect id="XMLID_9053_" width="3.7" height="5.1" transform="translate(322.2 111.9)" fill="#fff" />
                <rect id="XMLID_9052_" width="3.7" height="5.1" transform="translate(315.4 111.9)" fill="#fff" />
                <rect id="XMLID_9051_" width="3.7" height="5.1" transform="translate(302.9 111.9)" fill="#fff" />
                <rect id="XMLID_9050_" width="3.7" height="5.1" transform="translate(296.1 111.9)" fill="#fff" />
                <rect id="XMLID_9049_" width="3.7" height="5.1" transform="translate(289.3 111.9)" fill="#fff" />
              </g>
              <g id="XMLID_9037_">
                <rect id="XMLID_9047_" width="3.7" height="5.1" transform="translate(356.3 122.6)" fill="#fff" />
                <rect id="XMLID_9046_" width="3.7" height="5.1" transform="translate(349.5 122.6)" fill="#fff" />
                <rect id="XMLID_9045_" width="3.7" height="5.1" transform="translate(342.7 122.6)" fill="#fff" />
                <rect id="XMLID_9044_" width="3.7" height="5.1" transform="translate(335.9 122.6)" fill="#fff" />
                <rect id="XMLID_9043_" width="3.7" height="5.1" transform="translate(329 122.6)" fill="#fff" />
                <rect id="XMLID_9042_" width="3.7" height="5.1" transform="translate(322.2 122.6)" fill="#fff" />
                <rect id="XMLID_9041_" width="3.7" height="5.1" transform="translate(315.4 122.6)" fill="#fff" />
                <rect id="XMLID_9040_" width="3.7" height="5.1" transform="translate(302.9 122.6)" fill="#fff" />
                <rect id="XMLID_9039_" width="3.7" height="5.1" transform="translate(296.1 122.6)" fill="#fff" />
                <rect id="XMLID_9038_" width="3.7" height="5.1" transform="translate(289.3 122.6)" fill="#fff" />
              </g>
              <g id="XMLID_9026_">
                <rect id="XMLID_9036_" width="3.7" height="5.1" transform="translate(356.3 133.3)" fill="#fff" />
                <rect id="XMLID_9035_" width="3.7" height="5.1" transform="translate(349.5 133.3)" fill="#fff" />
                <rect id="XMLID_9034_" width="3.7" height="5.1" transform="translate(342.7 133.3)" fill="#fff" />
                <rect id="XMLID_9033_" width="3.7" height="5.1" transform="translate(335.9 133.3)" fill="#fff" />
                <rect id="XMLID_9032_" width="3.7" height="5.1" transform="translate(329 133.3)" fill="#fff" />
                <rect id="XMLID_9031_" width="3.7" height="5.1" transform="translate(322.2 133.3)" fill="#fff" />
                <rect id="XMLID_9030_" width="3.7" height="5.1" transform="translate(315.4 133.3)" fill="#fff" />
                <rect id="XMLID_9029_" width="3.7" height="5.1" transform="translate(302.9 133.3)" fill="#fff" />
                <rect id="XMLID_9028_" width="3.7" height="5.1" transform="translate(296.1 133.3)" fill="#fff" />
                <rect id="XMLID_9027_" width="3.7" height="5.1" transform="translate(289.3 133.3)" fill="#fff" />
              </g>
              <g id="XMLID_9014_">
                <rect id="XMLID_9025_" width="3.7" height="5.1" transform="translate(356.3 144)" fill="#fff" />
                <rect id="XMLID_9024_" width="3.7" height="5.1" transform="translate(349.5 144)" fill="#fff" />
                <rect id="XMLID_9023_" width="3.7" height="5.1" transform="translate(342.7 144)" fill="#fff" />
                <rect id="XMLID_9021_" width="3.7" height="5.1" transform="translate(335.9 144)" fill="#fff" />
                <rect id="XMLID_9020_" width="3.7" height="5.1" transform="translate(329 144)" fill="#fff" />
                <rect id="XMLID_9019_" width="3.7" height="5.1" transform="translate(322.2 144)" fill="#fff" />
                <rect id="XMLID_9018_" width="3.7" height="5.1" transform="translate(315.4 144)" fill="#fff" />
                <rect id="XMLID_9017_" width="3.7" height="5.1" transform="translate(302.9 144)" fill="#fff" />
                <rect id="XMLID_9016_" width="3.7" height="5.1" transform="translate(296.1 144)" fill="#fff" />
                <rect id="XMLID_9015_" width="3.7" height="5.1" transform="translate(289.3 144)" fill="#fff" />
              </g>
              <g id="XMLID_9003_">
                <rect id="XMLID_9013_" width="3.7" height="5.1" transform="translate(356.3 154.7)" fill="#fff" />
                <rect id="XMLID_9012_" width="3.7" height="5.1" transform="translate(349.5 154.7)" fill="#fff" />
                <rect id="XMLID_9011_" width="3.7" height="5.1" transform="translate(342.7 154.7)" fill="#fff" />
                <rect id="XMLID_9010_" width="3.7" height="5.1" transform="translate(335.9 154.7)" fill="#fff" />
                <rect id="XMLID_9009_" width="3.7" height="5.1" transform="translate(329 154.7)" fill="#fff" />
                <rect id="XMLID_9008_" width="3.7" height="5.1" transform="translate(322.2 154.7)" fill="#fff" />
                <rect id="XMLID_9007_" width="3.7" height="5.1" transform="translate(315.4 154.7)" fill="#fff" />
                <rect id="XMLID_9006_" width="3.7" height="5.1" transform="translate(302.9 154.7)" fill="#fff" />
                <rect id="XMLID_9005_" width="3.7" height="5.1" transform="translate(296.1 154.7)" fill="#fff" />
                <rect id="XMLID_9004_" width="3.7" height="5.1" transform="translate(289.3 154.7)" fill="#fff" />
              </g>
              <g id="XMLID_8992_">
                <rect id="XMLID_9002_" width="3.7" height="5.1" transform="translate(356.3 165.3)" fill="#fff" />
                <rect id="XMLID_9001_" width="3.7" height="5.1" transform="translate(349.5 165.3)" fill="#fff" />
                <rect id="XMLID_9000_" width="3.7" height="5.1" transform="translate(342.7 165.3)" fill="#fff" />
                <rect id="XMLID_8999_" width="3.7" height="5.1" transform="translate(335.9 165.3)" fill="#fff" />
                <rect id="XMLID_8998_" width="3.7" height="5.1" transform="translate(329 165.3)" fill="#fff" />
                <rect id="XMLID_8997_" width="3.7" height="5.1" transform="translate(322.2 165.3)" fill="#fff" />
                <rect id="XMLID_8996_" width="3.7" height="5.1" transform="translate(315.4 165.3)" fill="#fff" />
                <rect id="XMLID_8995_" width="3.7" height="5.1" transform="translate(302.9 165.3)" fill="#fff" />
                <rect id="XMLID_8994_" width="3.7" height="5.1" transform="translate(296.1 165.3)" fill="#fff" />
                <rect id="XMLID_8993_" width="3.7" height="5.1" transform="translate(289.3 165.3)" fill="#fff" />
              </g>
              <g id="XMLID_8980_">
                <rect id="XMLID_8991_" width="3.7" height="5.1" transform="translate(356.3 176)" fill="#fff" />
                <rect id="XMLID_8990_" width="3.7" height="5.1" transform="translate(349.5 176)" fill="#fff" />
                <rect id="XMLID_8989_" width="3.7" height="5.1" transform="translate(342.7 176)" fill="#fff" />
                <rect id="XMLID_8988_" width="3.7" height="5.1" transform="translate(335.9 176)" fill="#fff" />
                <rect id="XMLID_8987_" width="3.7" height="5.1" transform="translate(329 176)" fill="#fff" />
                <rect id="XMLID_8986_" width="3.7" height="5.1" transform="translate(322.2 176)" fill="#fff" />
                <rect id="XMLID_8985_" width="3.7" height="5.1" transform="translate(315.4 176)" fill="#fff" />
                <rect id="XMLID_8984_" width="3.7" height="5.1" transform="translate(302.9 176)" fill="#fff" />
                <rect id="XMLID_8982_" width="3.7" height="5.1" transform="translate(296.1 176)" fill="#fff" />
                <rect id="XMLID_8981_" width="3.7" height="5.1" transform="translate(289.3 176)" fill="#fff" />
              </g>
              <g id="XMLID_8969_">
                <rect id="XMLID_8979_" width="3.7" height="5.1" transform="translate(356.3 186.7)" fill="#fff" />
                <rect id="XMLID_8978_" width="3.7" height="5.1" transform="translate(349.5 186.7)" fill="#fff" />
                <rect id="XMLID_8977_" width="3.7" height="5.1" transform="translate(342.7 186.7)" fill="#fff" />
                <rect id="XMLID_8976_" width="3.7" height="5.1" transform="translate(335.9 186.7)" fill="#fff" />
                <rect id="XMLID_8975_" width="3.7" height="5.1" transform="translate(329 186.7)" fill="#fff" />
                <rect id="XMLID_8974_" width="3.7" height="5.1" transform="translate(322.2 186.7)" fill="#fff" />
                <rect id="XMLID_8973_" width="3.7" height="5.1" transform="translate(315.4 186.7)" fill="#fff" />
                <rect id="XMLID_8972_" width="3.7" height="5.1" transform="translate(302.9 186.7)" fill="#fff" />
                <rect id="XMLID_8971_" width="3.7" height="5.1" transform="translate(296.1 186.7)" fill="#fff" />
                <rect id="XMLID_8970_" width="3.7" height="5.1" transform="translate(289.3 186.7)" fill="#fff" />
              </g>
              <g id="XMLID_8958_">
                <rect id="XMLID_8968_" width="3.7" height="5.1" transform="translate(356.3 197.4)" fill="#fff" />
                <rect id="XMLID_8967_" width="3.7" height="5.1" transform="translate(349.5 197.4)" fill="#fff" />
                <rect id="XMLID_8966_" width="3.7" height="5.1" transform="translate(342.7 197.4)" fill="#fff" />
                <rect id="XMLID_8965_" width="3.7" height="5.1" transform="translate(335.9 197.4)" fill="#fff" />
                <rect id="XMLID_8964_" width="3.7" height="5.1" transform="translate(329 197.4)" fill="#fff" />
                <rect id="XMLID_8963_" width="3.7" height="5.1" transform="translate(322.2 197.4)" fill="#fff" />
                <rect id="XMLID_8962_" width="3.7" height="5.1" transform="translate(315.4 197.4)" fill="#fff" />
                <rect id="XMLID_8961_" width="3.7" height="5.1" transform="translate(302.9 197.4)" fill="#fff" />
                <rect id="XMLID_8960_" width="3.7" height="5.1" transform="translate(296.1 197.4)" fill="#fff" />
                <rect id="XMLID_8959_" width="3.7" height="5.1" transform="translate(289.3 197.4)" fill="#fff" />
              </g>
              <g id="XMLID_8947_">
                <rect id="XMLID_8957_" width="3.7" height="5.1" transform="translate(356.3 208.1)" fill="#fff" />
                <rect id="XMLID_8956_" width="3.7" height="5.1" transform="translate(349.5 208.1)" fill="#fff" />
                <rect id="XMLID_8955_" width="3.7" height="5.1" transform="translate(342.7 208.1)" fill="#fff" />
                <rect id="XMLID_8954_" width="3.7" height="5.1" transform="translate(335.9 208.1)" fill="#fff" />
                <rect id="XMLID_8953_" width="3.7" height="5.1" transform="translate(329 208.1)" fill="#fff" />
                <rect id="XMLID_8952_" width="3.7" height="5.1" transform="translate(322.2 208.1)" fill="#fff" />
                <rect id="XMLID_8951_" width="3.7" height="5.1" transform="translate(315.4 208.1)" fill="#fff" />
                <rect id="XMLID_8950_" width="3.7" height="5.1" transform="translate(302.9 208.1)" fill="#fff" />
                <rect id="XMLID_8949_" width="3.7" height="5.1" transform="translate(296.1 208.1)" fill="#fff" />
                <rect id="XMLID_8948_" width="3.7" height="5.1" transform="translate(289.3 208.1)" fill="#fff" />
              </g>
            </g>
            <path
              id="XMLID_8945_"
              d="M353.9,50.1H295.5v-8a5.228,5.228,0,0,1,5.2-5.2h48.1a5.228,5.228,0,0,1,5.2,5.2v8Z"
              fill="#e2e5ed"
            />
            <path id="XMLID_8942_" d="M322.3,36.9H300.4a5.149,5.149,0,0,0-5,5.3V50h26.8V36.9Z" fill="#e2e5ed" />
          </g>
        </g>
        <g id="XMLID_1996_">
          <g id="XMLID_2111_">
            <path
              id="XMLID_1991_"
              d="M220.7,275.8c-2.8-25.6-42.3-45.9-90.6-45.9s-87.8,20.3-90.6,45.9Z"
              fill="#cacdd8"
            />
            <path
              id="XMLID_1990_"
              d="M408.4,275.8c-2.6-25.6-38.7-45.9-82.8-45.9s-80.2,20.3-82.8,45.9Z"
              fill="#cacdd8"
            />
            <path
              id="XMLID_1989_"
              d="M313.1,275.8c-9.4-40.8-53.5-71.6-106.5-71.6s-97.1,30.9-106.5,71.6Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_2109_">
            <path
              id="XMLID_1988_"
              d="M317.3,199a51.512,51.512,0,0,0,5.4,27.1c7,13.2,13.5,8.6,13.5,8.6s7.1-3.5.1-16.6A47.149,47.149,0,0,0,317.3,199Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_2107_">
            <path
              id="XMLID_1987_"
              d="M120.1,205s-2.5,11.3,3,20.6,11.9,4.5,11.9,4.5,6.8-4,1.3-13.2C130.8,207.6,120.1,205,120.1,205Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_2105_">
            <path
              id="XMLID_1986_"
              d="M336.7,186a60.313,60.313,0,0,1,11.2,30.8c1.1,18-8.2,17.9-8.2,17.9s-9.2,1.4-10.3-16.6A60.446,60.446,0,0,1,336.7,186Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_2103_">
            <path
              id="XMLID_1985_"
              d="M139.9,174a72.524,72.524,0,0,1,10.8,37.8c-.2,21.6-11.3,20.6-11.3,20.6s-11.1.8-11-20.7A73.131,73.131,0,0,1,139.9,174Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_2100_">
            <path
              id="XMLID_1984_"
              d="M243.2,188.2s-4.9,10.4-1.5,20.8c3.3,10.4,10.6,7.3,10.6,7.3s7.5-2.2,4.2-12.6C253.1,193.3,243.2,188.2,243.2,188.2Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_2001_">
            <path
              id="XMLID_1983_"
              d="M269.3,162.8s7.2,18.5,2.3,39.4c-4.9,21-15.4,17.3-15.4,17.3s-11-1.9-6.2-22.9A70.339,70.339,0,0,1,269.3,162.8Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_1999_">
            <path
              id="XMLID_1982_"
              d="M306.7,234.3a4.385,4.385,0,0,1-2-3.9,4.1,4.1,0,0,1,2.6-3.3c.8-.2,1.7-.2,2.5-.4a2.474,2.474,0,0,0,1.9-1.5c.3-1.1-.6-2.3-.2-3.4a2.154,2.154,0,0,1,2.7-1.2,16.408,16.408,0,0,1,2.9,1.6,6.97,6.97,0,0,0,3.8,1c1.1,0,2.1-.2,3.2-.1a2.713,2.713,0,0,1,2.5,1.8c.3.9-.1,2,.4,2.7.5.8,1.6.9,2.3,1.4a2.6,2.6,0,0,1,.6,3.4Z"
              fill="#cacdd8"
            />
          </g>
          <g id="XMLID_1997_">
            <path
              id="XMLID_1981_"
              d="M190.6,205.1a5.179,5.179,0,0,1-2.1-4.9,4.605,4.605,0,0,1,3.5-3.7c1-.2,2-.1,3-.2a2.651,2.651,0,0,0,2.4-1.6c.5-1.3-.5-2.8,0-4.1a2.573,2.573,0,0,1,3.4-1.2,23.673,23.673,0,0,1,3.3,2.2,10.2,10.2,0,0,0,4.4,1.6,23.579,23.579,0,0,1,3.8.2,3.478,3.478,0,0,1,2.8,2.4c.2,1.1-.3,2.3.3,3.3.5,1,1.8,1.2,2.7,1.9a2.965,2.965,0,0,1,.4,4.1Z"
              fill="#cacdd8"
            />
          </g>
        </g>
        <g id="XMLID_14904_">
          <g id="XMLID_14905_">
            <path
              id="XMLID_14906_"
              d="M43.4,275.7c-6.1-4.7-10-14-8.7-22.3,1.4-8.3,7.4-15.3,14.6-17,4.2-1,8.5-.4,12.7-1s8.8-2.9,10.3-7.5c1.9-5.9-2-12.7-.1-18.6,2-5.9,9-7.6,14.2-5.5s9.4,6.6,14,10.1a37.591,37.591,0,0,0,18.7,7.2c5.4.5,10.9-.3,16.2.9s10.7,5,11.9,11.1c1,5-1.1,10.7,1.1,15.2,2.2,4.6,7.6,5.5,11.3,8.7,4.9,4.3,5.8,13.4,1.9,18.9H43.4Z"
              fill="#cacdd8"
            />
          </g>
        </g>
        <path
          id="XMLID_35505_"
          d="M57,284.6c0,13.8,81.2,25,181.3,25s181.3-11.2,181.3-25-81.2-25-181.3-25S57,270.8,57,284.6Z"
          fill="#ebeef7"
        />
        <g id="XMLID_2045_">
          <path
            id="XMLID_2099_"
            d="M142.8,261.8s-4.5,6.3-4.3,7.5c.1.7,7,6.9,7.9,6.1s-3.7-6.4-2.8-8.5a14.367,14.367,0,0,1,2.4-3.7Z"
            fill="#f2bbb8"
          />
          <path
            id="XMLID_2098_"
            d="M139.8,266.5c2.4,4.7,4.2,5,5,4.7,1,1.9,2.1,3.7,1.6,4.2-.9.8-7.8-5.4-7.9-6.1C138.4,268.9,139,267.8,139.8,266.5Z"
            fill="#060633"
          />
          <g id="XMLID_2095_">
            <path
              id="XMLID_2097_"
              d="M164.7,263.1s.4,4.5.5,5.3-.4,3.4.2,3.7c.7.3,7.9,3.8,8.5,2.6s-5.5-5.6-5.6-6.7-.3-5.7-.3-5.7Z"
              fill="#f2bbb8"
            />
            <path
              id="XMLID_2096_"
              d="M171.4,271.3c1.5,1.4,2.9,2.8,2.6,3.4-.6,1.2-7.9-2.3-8.5-2.6s-.2-2.5-.2-3.5C168.2,272.1,170.4,271.7,171.4,271.3Z"
              fill="#060633"
            />
          </g>
          <path id="XMLID_2094_" d="M167.7,204.9s4.3,11.6,9,18.7l2.3-1.3s-6.8-17.1-7.7-24l-4.2,1.4Z" fill="#f2bbb8" />
          <path
            id="XMLID_2093_"
            d="M154.2,212.1s-3.4,6.6-4,12.5-1.2,18.3-1.6,20.2-7.5,19-7.5,19l4.3,3.2s10.6-15,12.3-21.8c1.6-6.8,3.5-19.9,3.5-19.9s1.7,16.8,2.4,21.3,0,19.1,0,19.1h7.2a109.984,109.984,0,0,0,1.6-22.8c-.4-13.8-5.6-32.4-5.6-32.4Z"
            fill="#060633"
          />
          <path
            id="XMLID_2091_"
            d="M171.4,188.2a5.188,5.188,0,0,1-2.2-2.2c-.5-1.5.7-3.3.2-4.8-.4-1.2-1.8-1.8-2.5-2.8s-.7-2.2-1.1-3.4c-1.3-3.6-5.6-4.2-8.7-2.9-.5.2-.9.5-1.3.7a6.117,6.117,0,0,0-2.6,4.2c-.1,1.2.3,2.5-.5,3.5-.7.9-2,1.1-3,1.5a4.144,4.144,0,0,0-2.3,2.7c-.3,1.4.4,3.1-.5,4.2-.6.8-1.7,1-2.5,1.6a4.89,4.89,0,0,0-2,2.5,4.079,4.079,0,0,0,2,4.9,7.045,7.045,0,0,0,2.9.4,15.922,15.922,0,0,0,5.6-1.4c1.7-.8,3.4-1.8,5.2-2a19.587,19.587,0,0,1,4.8.5,24.3,24.3,0,0,1,4.7.8c.7.3,1.3.6,2,.9a3.762,3.762,0,0,0,2.1.1,1.49,1.49,0,0,0,.9-1.7,4.053,4.053,0,0,0-.5-.9c-.6-1.4,1.1-2.7,1.1-4.1A3.991,3.991,0,0,0,171.4,188.2Z"
            fill="#060633"
          />
          <path
            id="XMLID_2090_"
            d="M156.7,188.5c-3.1.3-8,1.9-10.5,6.7a40.394,40.394,0,0,0-3.6,9.2l6.9,2.1.6-2.7s2.2,8.4,4,9,2.9-.7,3.9-.9,4.5.7,7.2-.2c2.8-1,2.8-3.1,3-5.5.2-2.5.6-4.7.6-4.7l3.7-1.4s-3-9.7-6.6-10.5A46.939,46.939,0,0,0,156.7,188.5Z"
            fill={props.color1 ? props.color1 : '#ff4137'}
          />
          <path
            id="XMLID_2089_"
            d="M143.9,204.9a81.9,81.9,0,0,0,.5,10.7c.6,3.5,4.7,10.8,4.7,10.8l2.1-2.4s-4.3-10.2-2.7-17.7Z"
            fill="#f2bbb8"
          />
          <path id="XMLID_2088_" d="M165.3,180.3s.5-.6.8-.3c.8.8-.2,1.6-.8,1.7Z" fill="#ea6868" />
          <path
            id="XMLID_2087_"
            d="M160.6,171.9a5.309,5.309,0,0,0-5.4,4.5,5.229,5.229,0,0,0,.2,2.5,21.925,21.925,0,0,0,1.6,4.6,5.063,5.063,0,0,1,.5,3.8l-.3,1.3c2.9,1.8,4.4.4,4.4.4l.3-3.1h0c3.4-.1,3.5-6.2,3.7-8h0v-.2A5.1,5.1,0,0,0,160.6,171.9Z"
            fill="#f2bbb8"
          />
          <path
            id="XMLID_2086_"
            d="M159.7,177.2c-.7.6-1.3,1.3-2,1.9a5.358,5.358,0,0,0-1.6,2.4,7.079,7.079,0,0,1-1.6-2.8,4.013,4.013,0,0,1-.3-1.5,5.374,5.374,0,0,1,.5-2.1,5.112,5.112,0,0,1,1.3-2.4,4.171,4.171,0,0,1,1.6-.9,7.491,7.491,0,0,1,4.2-.3,5.542,5.542,0,0,1,3.4,2.4c.9,1.6.8,3.5.7,5.3a4.117,4.117,0,0,0-1-2.1,5.8,5.8,0,0,0-1-1.2c-.7-.5-.9-.5-2.1-1.4A5.688,5.688,0,0,1,159.7,177.2Z"
            fill="#060633"
          />
          <path
            id="XMLID_2085_"
            d="M156.9,180.5a.781.781,0,0,0-.4-.4,1.352,1.352,0,0,0-1.5,0c-.7.6.4,2.4,1.8,1.7A1.359,1.359,0,0,0,156.9,180.5Z"
            fill="#f2bbb8"
          />
          <path
            id="XMLID_2084_"
            d="M164.4,180.2c.1-.3-.1-.5-.4-.5-.3-.1-.5.1-.5.4-.1.3.1.5.4.5C164.1,180.6,164.4,180.5,164.4,180.2Z"
            fill="#060633"
          />
          <path
            id="XMLID_2083_"
            d="M160,180.3c.1-.3-.1-.5-.4-.5-.3-.1-.5.1-.5.4-.1.3.1.5.4.5C159.7,180.7,160,180.5,160,180.3Z"
            fill="#060633"
          />
          <path
            id="XMLID_2082_"
            d="M163.1,183.5a1.628,1.628,0,0,0-.6-.3,1.866,1.866,0,0,0-.4.3.446.446,0,0,0-.4-.3,7.471,7.471,0,0,0-1.1.2s.7,1.3,1.6,1.1a1.232,1.232,0,0,0,.9-1Z"
            fill="#ea6868"
          />
          <path
            id="XMLID_2081_"
            d="M162.2,183.9a2.5,2.5,0,0,1-1.9-.6v-.1h.1c.1.1,1.5,1.3,2.7.2h.1v.1A2.112,2.112,0,0,1,162.2,183.9Z"
            fill="#240d39"
          />
          <path
            id="XMLID_2080_"
            d="M158.6,179.5c-.1,0-.1,0-.1-.1-.1-.1,0-.2.1-.3a2.224,2.224,0,0,1,1.5-.2.2.2,0,0,1,0,.4,2.749,2.749,0,0,0-1.3.2Z"
            fill="#060633"
          />
          <path
            id="XMLID_2079_"
            d="M163.3,179.1a.1.1,0,0,1-.1-.1c0-.1,0-.2.1-.2a2.177,2.177,0,0,1,1.5,0c.1,0,.1.2.1.2,0,.1-.2.1-.2.1a1.649,1.649,0,0,0-1.3,0Z"
            fill="#060633"
          />
          <path
            id="XMLID_2078_"
            d="M161.9,182.2a.71.71,0,0,0,.8-.7v-.1a2.6,2.6,0,0,1-.3-1.5c0-.1,0-.2-.1-.2s-.2,0-.2.1a2.493,2.493,0,0,0,.3,1.7c0,.1-.2.4-.7.3-.1,0-.2,0-.2.1s0,.2.1.2A.367.367,0,0,0,161.9,182.2Z"
            fill="#ea6868"
          />
          <path id="XMLID_2077_" d="M168.7,201.5h0c.1-2.4-1.8-5.5-1.8-5.6h-.1v.1s1.9,3.2,1.9,5.5Z" fill="#272035" />
          <path
            id="XMLID_2076_"
            d="M155.9,203.7a7.314,7.314,0,0,0,3.6-1.3v-.1h-.1s-3.1,2.3-5.9.8h-.1v.1A4.677,4.677,0,0,0,155.9,203.7Z"
            fill="#272035"
          />
          <path
            id="XMLID_2075_"
            d="M150.7,223.6a22.174,22.174,0,0,1,2.9,2c.7.6,1.8.8,1.6,1.3s-1.9-.1-1.9-.1a20.308,20.308,0,0,0,.9,2.3c.3.5.5,1.6.2,1.8-.4.2-1.5-2.4-1.5-2.4s.8,2.3.5,2.6-1.7-2.5-1.7-2.5a28.318,28.318,0,0,1,.9,2.7c-.1.3-.4.1-1-.6a15.809,15.809,0,0,1-.9-1.7,19.266,19.266,0,0,1,.5,2c0,.2-.2.5-.9-.7a15.123,15.123,0,0,1-1.7-5.8Z"
            fill="#f2bbb8"
          />
          <path
            id="XMLID_2074_"
            d="M178.2,221.6a22.174,22.174,0,0,1,2.9,2c.7.6,1.8.8,1.6,1.3s-1.9-.1-1.9-.1a20.308,20.308,0,0,0,.9,2.3c.3.5.5,1.6.2,1.8-.4.2-1.5-2.4-1.5-2.4s.8,2.3.5,2.6-1.7-2.5-1.7-2.5a28.318,28.318,0,0,1,.9,2.7c-.1.3-.4.1-1-.6a15.809,15.809,0,0,1-.9-1.7,19.266,19.266,0,0,1,.5,2c0,.2-.2.5-.9-.7a15.123,15.123,0,0,1-1.7-5.8Z"
            fill="#f2bbb8"
          />
        </g>
        <g id="auto_1_">
          <path
            id="XMLID_2044_"
            d="M132,275.1l2.7,1.3a7.975,7.975,0,0,0,3.7.8H360.2a20.972,20.972,0,0,0,5.6-.7l21.2-5.3a7.6,7.6,0,0,0,5.6-9s.7-16.3-5.2-25.1c0,0,1.3-7.3-2.3-9.6,0,0,.4-6.6-1.1-7.2-1.5-.5-19-1.9-23.2-2.9-4.2-1.1-39-16.7-56.8-17.3s-54.4-2.3-71.6,4.2-41.8,20.8-41.8,20.8-48.7,5.1-56.7,18.1a61.228,61.228,0,0,0-7.5,21.1,10.062,10.062,0,0,0,5.6,10.8"
            fill="#1b202d"
          />
          <path
            id="XMLID_2043_"
            d="M199.4,230.3s27.8-21,49-23.5,64.2-5,89,9.5c0,0-9,7.3-11.2,7.7-2.1.3-101,6.9-107.6,7-6.5.2-19.2-.7-19.2-.7"
            fill="#3c414c"
          />
          <path
            id="XMLID_2042_"
            d="M232.4,204.4l3.2,1.5s-39.9,21.5-42.3,21.4a2.567,2.567,0,0,1-2.6-2.1s28.6-16.5,41.7-20.8"
            fill="#fff"
          />
          <path
            id="XMLID_2041_"
            d="M132,250.3s2.4-6.6,7.4-8.7,14.2-2.6,14.2-1.4-7.2,5.7-7.2,7.2a6.154,6.154,0,0,0,.9,2.9Z"
            fill="#fff"
          />
          <path
            id="XMLID_2040_"
            d="M133.1,268s.8,3.6,2,3.6,3.8-7.7,3.5-8.7c-.3-.9-6.7-.3-6.9-.2-.1.3,1.4,5.3,1.4,5.3"
            fill="#3c414c"
          />
          <path
            id="XMLID_2039_"
            d="M268.5,207.1l-3.4,20.2s-49.1,3.3-50.8,2.9c-1.7-.5-1.9-5.8,0-7.5s20.1-10.4,30.5-12.5a206.366,206.366,0,0,1,23.7-3.1"
            fill="#fff"
          />
          <path
            id="XMLID_2038_"
            d="M208.2,225.2s5.7-3.2,6.9-3.1,3.3,4.5,1.9,7l-7.5.6s-1.2-1.3-1.3-4.5"
            fill="#1b202d"
          />
          <path id="XMLID_2037_" d="M274.8,226.4l1.2-19.3s27.5.5,37.4,2.7l8.4,13.6-46.4,3.1h-.6Z" fill="#fff" />
          <path
            id="XMLID_2035_"
            d="M320.9,213.5l5.4,7.1a.925.925,0,0,0,1.2.2l4.6-3.6a.9.9,0,0,0-.2-1.5l-10-3.6a.921.921,0,0,0-1,1.4"
            fill="#fff"
          />
          <path
            id="XMLID_2034_"
            d="M302.3,272H208.6a6.527,6.527,0,0,1-6.4-5.3,103.191,103.191,0,0,1-1.7-18.1,68.2,68.2,0,0,1,2.7-18.8l.3.1a66.973,66.973,0,0,0-2.7,18.7,102.234,102.234,0,0,0,1.7,18.1,6.129,6.129,0,0,0,6.1,5.1h93.7a6,6,0,0,0,5.1-2.7L329.1,237a5.886,5.886,0,0,0,.1-6.6l-4.5-7,.2-.2,4.5,7a6.178,6.178,0,0,1-.1,7l-21.7,32.1a6.773,6.773,0,0,1-5.3,2.7"
            fill="#3c414c"
          />
          <path id="XMLID_2033_" d="M270,271.9c-4-15.7,0-45.7,0-46h.3c0,.3-4,30.2,0,45.9Z" fill="#3c414c" />
          <path id="XMLID_2032_" d="M261.1,240.3a3.838,3.838,0,1,0-3.8,3.3,3.525,3.525,0,0,0,3.8-3.3" fill="#575756" />
          <path
            id="XMLID_2031_"
            d="M264.1,239H250.3a.1.1,0,0,0-.1.1v2.1a.1.1,0,0,0,.1.1h13.8a.1.1,0,0,0,.1-.1l-.1-2.2h0"
            fill="#9b9b9b"
          />
          <path id="XMLID_2030_" d="M319.5,237.9a3.838,3.838,0,1,0-3.8,3.3,3.463,3.463,0,0,0,3.8-3.3" fill="#575756" />
          <path
            id="XMLID_2029_"
            d="M322.5,236.6H308.7a.1.1,0,0,0-.1.1v2.1a.1.1,0,0,0,.1.1h13.8a.1.1,0,0,0,.1-.1l-.1-2.2c.1.1.1,0,0,0"
            fill="#9b9b9b"
          />
          <path
            id="XMLID_2028_"
            d="M385.1,227.6H370c-3.1,0-7.3.5-4.5,2.3s11.9,5.1,11.6,6.2c-.2,1.1-.7,2.8-.7,2.8s9.5.3,11-1.8c0,0,1.4-7-2.3-9.5"
            fill="#fff"
          />
          <path
            id="XMLID_2027_"
            d="M359.5,266.7a21.9,21.9,0,1,0-21.9,21.9,21.894,21.894,0,0,0,21.9-21.9"
            fill="#3c414c"
          />
          <path
            id="XMLID_2024_"
            d="M337.6,283.4a16.6,16.6,0,1,1,16.6-16.6,16.559,16.559,0,0,1-16.6,16.6m0-31.7a15,15,0,1,0,15,15,14.98,14.98,0,0,0-15-15"
            fill="#ebeef7"
          />
          <path id="XMLID_2023_" d="M342.8,266.8a5.2,5.2,0,1,0-5.2,5.2,5.294,5.294,0,0,0,5.2-5.2" fill="#ebeef7" />
          <path id="XMLID_2022_" d="M338.4,262.8l1.8-11.3h-5.3l1.9,11.3Z" fill="#ebeef7" />
          <path id="XMLID_2021_" d="M341.4,264.6l8.8-7.4-4-3.5-6,9.8Z" fill="#ebeef7" />
          <path id="XMLID_2020_" d="M342.1,268.4l11.4,1-.3-5.3L342,266.8Z" fill="#ebeef7" />
          <path id="XMLID_2019_" d="M333.7,264.6l-8.7-7.4,4-3.5,5.9,9.8Z" fill="#ebeef7" />
          <path id="XMLID_2018_" d="M338.4,271.1l1.8,11.3h-5.3l1.9-11.3Z" fill="#ebeef7" />
          <path id="XMLID_2017_" d="M341.4,269.3l8.8,7.4-4,3.5-6-9.8Z" fill="#ebeef7" />
          <path id="XMLID_2016_" d="M333.7,269.4l-8.7,7.3,4,3.5,5.9-9.8Z" fill="#ebeef7" />
          <path id="XMLID_2015_" d="M333,268.4l-11.4,1,.4-5.3,11.1,2.7Z" fill="#ebeef7" />
          <path
            id="XMLID_2014_"
            d="M197.3,266.7a21.9,21.9,0,1,0-21.9,21.9,21.894,21.894,0,0,0,21.9-21.9"
            fill="#3c414c"
          />
          <path
            id="XMLID_2011_"
            d="M175.4,283.4A16.6,16.6,0,1,1,192,266.8a16.559,16.559,0,0,1-16.6,16.6m0-31.7a15,15,0,1,0,15,15,14.98,14.98,0,0,0-15-15"
            fill="#ebeef7"
          />
          <path id="XMLID_2010_" d="M180.6,266.8a5.2,5.2,0,1,0-5.2,5.2,5.294,5.294,0,0,0,5.2-5.2" fill="#ebeef7" />
          <path id="XMLID_2009_" d="M176.2,262.8l1.9-11.3h-5.3l1.9,11.3Z" fill="#ebeef7" />
          <path id="XMLID_2008_" d="M179.3,264.6l8.7-7.4-4-3.5-5.9,9.8Z" fill="#ebeef7" />
          <path id="XMLID_2007_" d="M180,268.4l11.4,1-.4-5.3-11.1,2.7Z" fill="#ebeef7" />
          <path id="XMLID_2006_" d="M171.6,264.6l-8.8-7.4,4-3.5,6,9.8Z" fill="#ebeef7" />
          <path id="XMLID_2005_" d="M176.2,271.1l1.9,11.3h-5.3l1.9-11.3Z" fill="#ebeef7" />
          <path id="XMLID_2004_" d="M179.3,269.3l8.7,7.4-4,3.5-5.9-9.8Z" fill="#ebeef7" />
          <path id="XMLID_2003_" d="M171.6,269.4l-8.8,7.3,4,3.5,6-9.8Z" fill="#ebeef7" />
          <path id="XMLID_2002_" d="M170.9,268.4l-11.4,1,.3-5.3,11.2,2.7Z" fill="#ebeef7" />
        </g>
        <g id="XMLID_2046_">
          <path
            id="XMLID_2073_"
            d="M302.2,204.3s-8.5,7.5-12.5,7.4c-5.9-.2-13.3-9.3-13.3-9.3l1.3-2s10.5,5.1,12,4.5,8.1-5.4,8.1-5.4S301.6,202.1,302.2,204.3Z"
            fill="#f2bbb8"
          />
          <g id="XMLID_2069_">
            <path id="XMLID_2072_" d="M304,290.2l1.1-6.6,3.5-.2-.7,7.2S305,291.1,304,290.2Z" fill="#fff" />
            <path
              id="XMLID_2071_"
              d="M308,290.1a7.967,7.967,0,0,1-4,.1s-6.6,2.5-6.5,4.5c0,0-.3.6,2.7.6h7.7C308.1,295.2,309.5,294.5,308,290.1Z"
              fill="#060633"
            />
            <path
              id="XMLID_2070_"
              d="M308.1,295.2c-.1.1-4.8,0-7.8,0s-2.7-.6-2.7-.6a.6.6,0,0,1,.1-.4l11-.3C308.6,295,308.2,295.2,308.1,295.2Z"
              fill="#fff"
            />
          </g>
          <g id="XMLID_2065_">
            <path id="XMLID_2068_" d="M327.2,290.2l-1.8-6.4,4.4-.7,1.3,7.5S328.1,291.1,327.2,290.2Z" fill="#fff" />
            <path
              id="XMLID_2067_"
              d="M331.1,290.1a7.967,7.967,0,0,1-4,.1s-6.6,2.5-6.5,4.5c0,0-.3.6,2.7.6H331C331.2,295.2,332.6,294.5,331.1,290.1Z"
              fill="#060633"
            />
            <path
              id="XMLID_2066_"
              d="M331.3,295.2c-.1.1-4.8,0-7.8,0s-2.7-.6-2.7-.6a.6.6,0,0,1,.1-.4l11-.3C331.7,295,331.3,295.2,331.3,295.2Z"
              fill="#fff"
            />
          </g>
          <path
            id="XMLID_2064_"
            d="M327.6,228.8l3.8,58.4h-5.9l-10.3-44-5.9,44h-5.7s.4-50.1,0-58.4C303.1,220.6,327.6,228.8,327.6,228.8Z"
            fill="#fff"
          />
          <path
            id="XMLID_2063_"
            d="M319.7,187.9s11,3.3,12.7,6.3,2.1,10.9,2.1,10.9l-6.2,1,.1,26.2s-9.6,3.4-25.3,0V205.8l-1.8,1.1-5.5-7.8s7.7-8.8,11.5-9.9A36.2,36.2,0,0,1,319.7,187.9Z"
            fill={props.color1 ? props.color1 : '#ff4137'}
          />
          <path
            id="XMLID_2062_"
            d="M333.9,205.1s-.1,11.7-3.5,12.1-8.6-8.3-11.2-16.2l3.1-.6,4.8,5.6v-1.7C327,204.3,332.3,204.1,333.9,205.1Z"
            fill="#f2bbb8"
          />
          <g id="XMLID_2048_">
            <path id="XMLID_2061_" d="M312.3,177.7s-.4-.8-.8-.5c-1.1.7-.2,1.7.5,2Z" fill="#ea6868" />
            <path
              id="XMLID_2060_"
              d="M312.3,175h0v-.2a6.085,6.085,0,0,1,7.1-5.3,6,6,0,0,1,5.2,5.8,5.467,5.467,0,0,1-.8,2.9c-.7,1.3-1.3,2.5-1.9,3.4a7.974,7.974,0,0,0-1.3,5.2l.1,1.4c-3.9,1.6-5.5-.3-5.5-.3l.2-2.6a.73.73,0,0,0-.6-.7h0C310.2,183.9,312.1,177,312.3,175Z"
              fill="#f2bbb8"
            />
            <path id="XMLID_2059_" d="M318.3,178.7a.552.552,0,1,1,.5.6A.634.634,0,0,1,318.3,178.7Z" fill="#060633" />
            <path id="XMLID_2058_" d="M313.4,177.2a.552.552,0,1,1,.5.6A.5.5,0,0,1,313.4,177.2Z" fill="#060633" />
            <path
              id="XMLID_2057_"
              d="M320.4,178h.2a.4.4,0,0,0,.2-.4,1.787,1.787,0,0,0-2.4-.8c-.2.1-.3.3-.2.4a.4.4,0,0,0,.4.2,1.126,1.126,0,0,1,1.5.4C320.2,177.9,320.3,178,320.4,178Z"
              fill="#060633"
            />
            <path
              id="XMLID_2056_"
              d="M315.2,176.7h.2a.4.4,0,0,0,.2-.4,1.787,1.787,0,0,0-2.4-.8c-.2.1-.3.3-.2.4a.4.4,0,0,0,.4.2,1.126,1.126,0,0,1,1.5.4C315,176.6,315.1,176.7,315.2,176.7Z"
              fill="#060633"
            />
            <path id="XMLID_2055_" d="M325,176.3l-2,3.9-1.1-.4-.2-5.2Z" fill="#1b202d" />
            <path
              id="XMLID_2054_"
              d="M321.8,179.7a1,1,0,0,1,.5-.4,1.828,1.828,0,0,1,1.7.3c.7.8-1,2.6-2.4,1.5C321.5,181.1,321.1,180.7,321.8,179.7Z"
              fill="#f2bbb8"
            />
            <path
              id="XMLID_2053_"
              d="M315.2,180.4a1.207,1.207,0,0,0,1,.1s.1-.1,0-.1c0,0-.1-.1-.1,0a.978.978,0,0,1-1.1-.2.31.31,0,0,1-.1-.2c0-.1.1-.1.2-.2a2.584,2.584,0,0,0,1-1.7c0-.1,0-.1-.1-.1s-.1,0-.1.1a2.913,2.913,0,0,1-.9,1.6c-.2.1-.3.2-.3.4,0,.1,0,.2.2.3A.187.187,0,0,1,315.2,180.4Z"
              fill="#ea6868"
            />
            <path
              id="XMLID_2052_"
              d="M313.5,172.8s-.9.5-1.5,4.1c0,0,.1-4,.6-4.4S313.5,172.8,313.5,172.8Z"
              fill="#1b202d"
            />
            <path
              id="XMLID_2050_"
              d="M316.9,181.9l-3.4-.8s-.7,1.4,1.1,1.9A1.853,1.853,0,0,0,316.9,181.9Z"
              fill="#fff"
            />
            <path
              id="XMLID_2049_"
              d="M325.7,174.6a8.33,8.33,0,0,0-.3-2.2,2.937,2.937,0,0,0-1.3-1.8,2.407,2.407,0,0,1-.8-.6l-.3-.6a2.282,2.282,0,0,0-2.5-.8,6.578,6.578,0,0,1-2.8.4c-1-.2-2-1-3-.6a4.7,4.7,0,0,0-.9.6,4.433,4.433,0,0,1-2,.3,2.055,2.055,0,0,0-1.8.8,1.324,1.324,0,0,0,.6,2c.1.1.3.1.4.2.6.4.2,1.4.7,1.8a1.093,1.093,0,0,0,1,.2,3.553,3.553,0,0,1,1-.2c.8,0,1.3.7,2.1.9,1,.2,2-.6,3.1-.6,1.6,0,2.5,1.9,4,2.4C324.7,177.2,325.6,176.2,325.7,174.6Z"
              fill="#1b202d"
            />
          </g>
          <path
            id="XMLID_2047_"
            d="M322.1,201a32.957,32.957,0,0,0,.6-3.9c0-1,.7-2,.1-2.2s-1.3,1.6-1.3,1.6a26.032,26.032,0,0,1-1.2-2.4c-.2-.6-.9-1.6-1.3-1.4-.5.1.8,2.9.8,2.9s-1.3-2.3-1.7-2.2c-.4,0,.8,3.1.8,3.1a24.334,24.334,0,0,0-1.5-2.6c-.3-.1-.4.2-.2,1.2a7.483,7.483,0,0,0,.7,1.9,14.018,14.018,0,0,0-1.2-1.8c-.2-.2-.6-.2-.1,1.2a16.488,16.488,0,0,0,3.5,5.5Z"
            fill="#f2bbb8"
          />
          <path
            id="XMLID_2101_"
            d="M278,200.8a28.487,28.487,0,0,0-1.3-3.7c-.5-.9-.3-2.1-.9-2s-.4,2-.4,2a21.56,21.56,0,0,1-2.2-1.6c-.5-.4-1.5-1-1.9-.6-.3.3,2.1,2.2,2.1,2.2s-2.2-1.4-2.6-1.2,2.2,2.4,2.2,2.4a19.71,19.71,0,0,0-2.6-1.6c-.3,0-.3.4.4,1.2a9.237,9.237,0,0,0,1.6,1.4,16.453,16.453,0,0,0-1.9-1c-.2,0-.6.1.5,1.1a17.081,17.081,0,0,0,5.6,3.2Z"
            fill="#f2bbb8"
          />
        </g>
        <g id="arbre">
          <g id="XMLID_13595_">
            <g id="XMLID_13596_">
              <path
                id="Tracé_1"
                data-name="Tracé 1"
                d="M457.4,132.9c5.1-.9,8.6,4.4,9.6,9.1.5,2.5.5,5.4,2.5,7.1a15.569,15.569,0,0,0,2.8,1.6c5.6,2.9,6,8.3,6.1,13.8a5.025,5.025,0,0,0,.5,2.7c.5.9,1.5,1.4,2.1,2.3a4.793,4.793,0,0,1,.7,2c1.4,6.2.7,11.9.6,18.1-.3,44.1-24.3,42-24.3,42h-.9c-5.8-.3-11-3.9-14.5-8.4-3.5-4.6-5.5-10.3-6.7-16a89.834,89.834,0,0,1-1.5-12.7c-.3-4.6-1.2-8.9.6-13.3.8-2,2.1-4,2.1-6.2,0-2.4-1.5-4.6-1.6-7a12.667,12.667,0,0,1,.9-4.2,66.546,66.546,0,0,1,4.4-9.8c1.4-2.4,4.5-3.7,5.3-6.4a12.968,12.968,0,0,0,.2-3.4c.2-5.6,5.1-9.6,10.1-11A4.283,4.283,0,0,1,457.4,132.9Z"
                fill="url(#linear-gradient)"
              />
              <g id="XMLID_14890_" clip-path="url(#clip-path)">
                <g id="XMLID_14902_">
                  <path
                    id="XMLID_14903_"
                    d="M458.2,231.9a.265.265,0,0,0,.3-.3l.8-108.6a.3.3,0,1,0-.6,0l-.8,108.6A.265.265,0,0,0,458.2,231.9Z"
                    fill="#fff"
                  />
                </g>
                <path
                  id="XMLID_14901_"
                  d="M458.7,149.4c-.1,0-8.7-3.7-13.9-10.3.1-.2.2-.5.3-.7,5,6.7,13.7,10.4,13.8,10.4Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14900_"
                  d="M458.9,129a39.778,39.778,0,0,1-7.4-4.3l.3-.6a44.151,44.151,0,0,0,7.3,4.2Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14899_"
                  d="M458.7,160c-.1-.1-11.3-4.7-16.6-13.3.1-.3.2-.5.3-.8,5.1,8.7,16.5,13.5,16.6,13.5Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14898_"
                  d="M458.3,206.1c-.2-.1-16.3-6.9-23.7-19.3v-1.3c6.9,12.8,23.7,19.9,23.9,20Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14897_"
                  d="M458.4,222.5l-.3.6c-.2-.1-14.4-6.1-22.2-17.1-.1-.5-.2-1.1-.3-1.6C443.1,216.1,458.2,222.4,458.4,222.5Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14896_"
                  d="M458.6,178c-.2-.1-13.6-5.7-20.9-16.1.1-.3.1-.6.2-.9,7.1,10.5,20.8,16.3,20.9,16.4Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14895_"
                  d="M470.6,133.5A42.4,42.4,0,0,1,459,141l-.2-.6a38.579,38.579,0,0,0,11.6-7.6A2.544,2.544,0,0,1,470.6,133.5Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14894_"
                  d="M458.9,154.2l-.2-.6c.1,0,9.8-4,15.4-11.3.1.2.2.5.3.7C468.6,150.3,459,154.1,458.9,154.2Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14893_"
                  d="M458.6,194.9l-.2-.6c.2-.1,16.1-6.5,23.5-18.5,0,.4.1.7.1,1.1C474.2,188.6,458.8,194.8,458.6,194.9Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14892_"
                  d="M458.2,217.2c.2-.1,16.7-6.7,24-19.2,0,.5-.1,1-.1,1.5-7.7,11.9-23.4,18.2-23.6,18.3Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_14891_"
                  d="M478.5,156.8c.1.3.1.5.2.8-7.6,9.4-19.9,14.4-20.1,14.4l-.2-.6C458.6,171.3,471.1,166.3,478.5,156.8Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
          <path id="XMLID_13594_" d="M461.8,276.6h-5.7L458,206l.8-1.8Z" fill="#e2e5ed" />
        </g>
        <g id="arbre_1_">
          <g id="XMLID_12284_">
            <g id="XMLID_12285_">
              <path
                id="Tracé_3"
                data-name="Tracé 3"
                d="M411.2,98.5c6.3-1.1,10.7,5.5,12,11.3.7,3.1.7,6.7,3.1,8.8a14.789,14.789,0,0,0,3.5,1.9c7,3.6,7.4,10.3,7.6,17.1a7.451,7.451,0,0,0,.6,3.3c.7,1.1,1.9,1.7,2.6,2.8a6.989,6.989,0,0,1,.9,2.4c1.8,7.7.8,14.7.8,22.4-.4,54.6-30.1,52-30.1,52H411c-7.2-.3-13.7-4.8-17.9-10.3-4.4-5.7-6.8-12.8-8.3-19.8a103.4,103.4,0,0,1-1.8-15.7c-.3-5.7-1.5-11,.7-16.5,1-2.5,2.6-5,2.6-7.7,0-3-1.8-5.7-1.9-8.7a11.986,11.986,0,0,1,1.2-5.2,87.45,87.45,0,0,1,5.4-12.1c1.7-2.9,5.6-4.6,6.6-8a19.8,19.8,0,0,0,.3-4.2c.2-7,6.3-11.9,12.6-13.6C410.6,98.6,410.9,98.6,411.2,98.5Z"
                fill="url(#linear-gradient-2)"
              />
              <g id="XMLID_13579_" clip-path="url(#clip-path-2)">
                <g id="XMLID_13591_">
                  <path
                    id="XMLID_13592_"
                    d="M412.1,221.2a.43.43,0,0,0,.4-.4l1-134.6a.4.4,0,1,0-.8,0l-1,134.6A.43.43,0,0,0,412.1,221.2Z"
                    fill="#fff"
                  />
                </g>
                <path
                  id="XMLID_13590_"
                  d="M412.8,118.9c-.1-.1-10.7-4.5-17.2-12.8a3.553,3.553,0,0,1,.4-.9c6.2,8.3,17,12.8,17.1,12.9Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13589_"
                  d="M413,93.8a45.66,45.66,0,0,1-9.2-5.3c.1-.2.3-.5.4-.7a45.81,45.81,0,0,0,9.1,5.2Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13588_"
                  d="M412.7,132.2c-.2-.1-14-5.9-20.6-16.5a4.18,4.18,0,0,1,.4-1c6.3,10.8,20.4,16.7,20.6,16.8Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13587_"
                  d="M412.2,189.3c-.2-.1-20.3-8.5-29.3-24a8.6,8.6,0,0,1,.1-1.6c8.6,15.9,29.4,24.7,29.6,24.8Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13586_"
                  d="M412.4,209.6l-.3.8c-.2-.1-17.9-7.5-27.6-21.2-.1-.6-.2-1.3-.3-2C393.4,201.6,412.2,209.5,412.4,209.6Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13585_"
                  d="M412.6,154.5c-.2-.1-16.8-7.1-25.9-19.9a4.253,4.253,0,0,0,.2-1.1c8.8,13,25.7,20.2,26,20.3Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13584_"
                  d="M427.5,99.3a49.7,49.7,0,0,1-14.4,9.3l-.3-.8a49.84,49.84,0,0,0,14.4-9.4A4.647,4.647,0,0,0,427.5,99.3Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13583_"
                  d="M413,124.9l-.3-.8c.2-.1,12.2-4.9,19.1-14l.3.9C425,120,413.1,124.8,413,124.9Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13582_"
                  d="M412.6,175.4l-.3-.8c.2-.1,19.9-8,29.2-22.9,0,.4.1.9.1,1.3C432,167.5,412.8,175.3,412.6,175.4Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13581_"
                  d="M412.1,203c.2-.1,20.7-8.3,29.7-23.8-.1.6-.1,1.3-.2,1.9-9.5,14.8-29,22.6-29.2,22.7Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_13580_"
                  d="M437.3,128.1a3.553,3.553,0,0,1,.2,1c-9.4,11.6-24.7,17.8-24.9,17.9l-.3-.8C412.6,146.2,428.1,139.9,437.3,128.1Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
          <path id="XMLID_12283_" d="M416.6,280.6l-7.1-4,2.3-87.5,1.1-2.2Z" fill="#fff" />
        </g>
        <g id="arbre_2_">
          <g id="XMLID_10973_">
            <g id="XMLID_10974_">
              <path
                id="Tracé_5"
                data-name="Tracé 5"
                d="M56.6,105.5c6.3-1.1,10.7,5.5,12,11.3.7,3.1.7,6.7,3.1,8.8a14.79,14.79,0,0,0,3.5,1.9c7,3.6,7.4,10.3,7.6,17.1a7.451,7.451,0,0,0,.6,3.3c.7,1.1,1.9,1.7,2.6,2.8a6.989,6.989,0,0,1,.9,2.4c1.8,7.7.8,14.7.8,22.4-.4,54.6-30.1,52-30.1,52H56.4c-7.2-.3-13.7-4.8-17.9-10.3-4.4-5.7-6.8-12.8-8.3-19.8a103.407,103.407,0,0,1-1.8-15.7c-.3-5.7-1.5-11,.7-16.5,1-2.5,2.6-5,2.6-7.7,0-3-1.8-5.7-1.9-8.7a11.986,11.986,0,0,1,1.2-5.2,87.451,87.451,0,0,1,5.4-12.1c1.7-2.9,5.6-4.6,6.6-8a19.806,19.806,0,0,0,.3-4.2c.2-7,6.3-11.9,12.6-13.6A6.371,6.371,0,0,1,56.6,105.5Z"
                fill="url(#linear-gradient-3)"
              />
              <g id="XMLID_12268_" clip-path="url(#clip-path-3)">
                <g id="XMLID_12280_">
                  <path
                    id="XMLID_12281_"
                    d="M57.6,228.2a.43.43,0,0,0,.4-.4L59,93.2a.4.4,0,1,0-.8,0l-1,134.6A.43.43,0,0,0,57.6,228.2Z"
                    fill="#fff"
                  />
                </g>
                <path
                  id="XMLID_12279_"
                  d="M58.2,125.9c-.1-.1-10.7-4.5-17.2-12.8a3.552,3.552,0,0,1,.4-.9c6.2,8.3,17,12.8,17.1,12.9Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12278_"
                  d="M58.4,100.8a45.66,45.66,0,0,1-9.2-5.3c.1-.2.3-.5.4-.7a45.81,45.81,0,0,0,9.1,5.2Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12277_"
                  d="M58.1,139.2c-.2-.1-14-5.9-20.6-16.5a4.179,4.179,0,0,1,.4-1c6.3,10.8,20.4,16.7,20.6,16.8Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12276_"
                  d="M57.7,196.3c-.2-.1-20.3-8.5-29.3-24a8.6,8.6,0,0,1,.1-1.6c8.6,15.9,29.4,24.7,29.6,24.8Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12275_"
                  d="M57.8,216.6l-.3.8c-.2-.1-17.9-7.5-27.6-21.2-.1-.6-.2-1.3-.3-2C38.8,208.6,57.6,216.5,57.8,216.6Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12274_"
                  d="M58.1,161.5c-.2-.1-16.8-7.1-25.9-19.9a4.253,4.253,0,0,0,.2-1.1c8.8,13,25.7,20.2,26,20.3Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12273_"
                  d="M73,106.3a49.7,49.7,0,0,1-14.4,9.3l-.3-.8a49.841,49.841,0,0,0,14.4-9.4A1.9,1.9,0,0,0,73,106.3Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12272_"
                  d="M58.4,131.9l-.3-.8c.2-.1,12.2-4.9,19.1-14l.3.9C70.4,127,58.6,131.8,58.4,131.9Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12271_"
                  d="M58,182.4l-.3-.8c.2-.1,19.9-8,29.2-22.9,0,.4.1.9.1,1.3C77.4,174.5,58.3,182.3,58,182.4Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12270_"
                  d="M57.5,210c.2-.1,20.7-8.3,29.7-23.8-.1.6-.1,1.3-.2,1.9-9.5,14.8-29,22.6-29.2,22.7Z"
                  fill="#fff"
                />
                <path
                  id="XMLID_12269_"
                  d="M82.8,135.1a3.553,3.553,0,0,1,.2,1c-9.4,11.6-24.7,17.8-24.9,17.9l-.3-.8C58,153.2,73.5,146.9,82.8,135.1Z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
          <path id="XMLID_10972_" d="M62.1,283.6H54.9l2.4-87.5,1-2.2Z" fill="#fff" />
        </g>
        <g id="XMLID_10958_">
          <path
            id="XMLID_10970_"
            d="M17.6,284c-3.7-2.5-6.1-7.5-5.3-11.9a11.7,11.7,0,0,1,8.9-9.1c2.5-.5,5.2-.2,7.8-.5s5.3-1.5,6.3-4c1.2-3.1-1.2-6.8,0-9.9,1.2-3.2,5.5-4,8.7-2.9s5.7,3.5,8.6,5.4A24.534,24.534,0,0,0,64,254.9c3.3.3,6.6-.2,9.9.5,3.2.6,6.5,2.7,7.3,5.9.6,2.7-.7,5.7.7,8.1s4.7,2.9,6.9,4.6a7.351,7.351,0,0,1,1.1,10.1H17.6Z"
            fill="url(#linear-gradient-4)"
          />
          <g id="XMLID_10969_">
            <path
              id="XMLID_10968_"
              d="M58.3,283.9c-.1-.3-10.4-26.9-20.4-38.1-.2.1-.3.2-.5.3,9.7,10.7,19.7,36.1,20.4,37.9h.3Z"
              fill="#fff"
            />
            <path
              id="XMLID_10967_"
              d="M13,269.8c10.2,6.5,25.5,7.6,34.6,7.6,4.5,0,7.5-.3,7.6-.3l-.1-.6c-.3,0-26.8,2.4-41.8-7.2A2.186,2.186,0,0,0,13,269.8Z"
              fill="#fff"
            />
            <path
              id="XMLID_10966_"
              d="M77.2,260.4c.9-.6,1.7-1.1,2.5-1.7a.781.781,0,0,0-.4-.4A39.685,39.685,0,0,1,50,265.6l-.1.6a39.892,39.892,0,0,0,5.9.4A41.2,41.2,0,0,0,77.2,260.4Z"
              fill="#fff"
            />
            <path
              id="XMLID_10965_"
              d="M90.9,277.8c-5.4.4-18.9,0-27.7-12.4l-.5.3c7.8,11,19.2,12.7,25.7,12.7a20.12,20.12,0,0,0,2.6-.1A1.087,1.087,0,0,0,90.9,277.8Z"
              fill="#fff"
            />
            <path
              id="XMLID_10964_"
              d="M26.7,262.6a39.385,39.385,0,0,1,4.1,13.3h.6a37.33,37.33,0,0,0-4-13.3Z"
              fill="#fff"
            />
            <path
              id="XMLID_10963_"
              d="M47.1,247.3a2.092,2.092,0,0,1-.6-.4,26.2,26.2,0,0,1-2.3,8.5l.5.3A22.8,22.8,0,0,0,47.1,247.3Z"
              fill="#fff"
            />
            <path
              id="XMLID_10962_"
              d="M38.1,284H39a24.485,24.485,0,0,0,5.5-6.8L44,277A24.644,24.644,0,0,1,38.1,284Z"
              fill="#fff"
            />
            <path
              id="XMLID_10961_"
              d="M33.6,260.6A24.4,24.4,0,0,0,43.7,263a13.557,13.557,0,0,0,4.5-.7l-.2-.5c-.1,0-5.3,2.2-13.9-1.6A1,1,0,0,1,33.6,260.6Z"
              fill="#fff"
            />
            <path
              id="XMLID_10960_"
              d="M56,266.2a11.564,11.564,0,0,1,5.3-11.7,2.354,2.354,0,0,1-.8-.2c-6.4,4.4-5.1,11.9-5.1,11.9Z"
              fill="#fff"
            />
            <path id="XMLID_10959_" d="M68,271l-.5-.2c0,.1-4.2,8.6.3,13.2h.8C63.8,279.8,68,271.1,68,271Z" fill="#fff" />
          </g>
        </g>
        <g id="nuage2_1_">
          <path
            id="XMLID_9406_"
            d="M146.8,22.1a9.859,9.859,0,0,1,7.8,3.8,7.564,7.564,0,0,1,6.6-3.8,7.3,7.3,0,0,1,4.1,1.2,14.365,14.365,0,0,1,14-11.1,14.514,14.514,0,0,1,14.3,12.3,6.85,6.85,0,0,1,6,4.5,5.133,5.133,0,0,1,5,4.9H137.3a14.918,14.918,0,0,1-.2-2.1A9.645,9.645,0,0,1,146.8,22.1Z"
            fill="#c3cae5"
          />
          <g id="XMLID_9322_">
            <path id="XMLID_9405_" d="M191.7,19a15.517,15.517,0,0,0-4.6-4.6Z" fill="#fff" />
            <path id="XMLID_9404_" d="M191.7,19l-4.6-4.6A15.517,15.517,0,0,1,191.7,19Z" fill="#fff" />
            <path id="XMLID_9402_" d="M183.5,12.8a2.92,2.92,0,0,0-.9-.2Z" fill="#fff" />
            <path id="XMLID_9401_" d="M182.6,12.6c.3.1.6.1.9.2l9.8,9.8a2.92,2.92,0,0,1,.2.9Z" fill="#fff" />
            <path
              id="XMLID_9400_"
              d="M195.7,24.9l4,4V29h0l4.9,4.9H204l-9.3-9.3C195,24.7,195.3,24.8,195.7,24.9Z"
              fill="#fff"
            />
            <path id="XMLID_9398_" d="M180.3,12.2h0Z" fill="#fff" />
            <path id="XMLID_9397_" d="M180.3,12.2,202.1,34h-.7L179.6,12.2Z" fill="#fff" />
            <path id="XMLID_9395_" d="M177.8,12.3a1.268,1.268,0,0,0-.6.1Z" fill="#fff" />
            <path id="XMLID_9394_" d="M177.8,12.3,199.4,34h-.7L177.1,12.4A1.952,1.952,0,0,1,177.8,12.3Z" fill="#fff" />
            <path id="XMLID_9393_" d="M175.6,12.7c-.2,0-.3.1-.5.2Z" fill="#fff" />
            <path
              id="XMLID_9391_"
              d="M175.6,12.7,196.8,34h-.7L175,12.9C175.2,12.8,175.4,12.8,175.6,12.7Z"
              fill="#fff"
            />
            <path id="XMLID_9390_" d="M173.6,13.4c-.2.1-.3.1-.5.2Z" fill="#fff" />
            <path
              id="XMLID_9388_"
              d="M173.6,13.4,194.2,34h-.7L173.2,13.7C173.3,13.6,173.5,13.5,173.6,13.4Z"
              fill="#fff"
            />
            <path id="XMLID_9387_" d="M171.9,14.3c-.1.1-.3.2-.4.3Z" fill="#fff" />
            <path id="XMLID_9385_" d="M171.9,14.3,191.5,34h-.7L171.4,14.6A2.186,2.186,0,0,0,171.9,14.3Z" fill="#fff" />
            <path id="XMLID_9383_" d="M170.3,15.4a1.381,1.381,0,0,1-.4.3Z" fill="#fff" />
            <path id="XMLID_9382_" d="M170.3,15.4,188.9,34h-.7L170,15.7Z" fill="#fff" />
            <path id="XMLID_9381_" d="M169,16.7l-.3.3Z" fill="#fff" />
            <path id="XMLID_9379_" d="M169,16.7,186.3,34h-.7l-17-17A1.381,1.381,0,0,0,169,16.7Z" fill="#fff" />
            <path id="XMLID_9377_" d="M167.8,18.1c-.1.1-.2.3-.3.4Z" fill="#fff" />
            <path
              id="XMLID_9376_"
              d="M167.8,18.1,183.7,34H183L167.5,18.5C167.6,18.4,167.7,18.2,167.8,18.1Z"
              fill="#fff"
            />
            <path id="XMLID_9374_" d="M166.8,19.7a.758.758,0,0,0-.2.4Z" fill="#fff" />
            <path id="XMLID_9372_" d="M166.8,19.7,181,34h-.7L166.5,20.2C166.6,20,166.7,19.9,166.8,19.7Z" fill="#fff" />
            <path id="XMLID_9370_" d="M165.9,21.5c-.1.2-.1.3-.2.5Z" fill="#fff" />
            <path id="XMLID_9369_" d="M165.9,21.5,178.4,34h-.7l-12-12C165.8,21.8,165.9,21.7,165.9,21.5Z" fill="#fff" />
            <path id="XMLID_9367_" d="M164.7,22.9c-.4-.2-.7-.3-1.1-.5Z" fill="#fff" />
            <path id="XMLID_9366_" d="M164.7,22.9,175.8,34h-.7L163.6,22.5A7.6,7.6,0,0,1,164.7,22.9Z" fill="#fff" />
            <path id="XMLID_9365_" d="M161.2,22.1h0Z" fill="#fff" />
            <path id="XMLID_9363_" d="M161.2,22.1,173.1,34h-.7L160.5,22.1Z" fill="#fff" />
            <path id="XMLID_9361_" d="M159,22.4c-.2.1-.3.1-.5.2Z" fill="#fff" />
            <path id="XMLID_9360_" d="M159,22.4,170.5,34h-.7L158.4,22.6C158.6,22.5,158.8,22.5,159,22.4Z" fill="#fff" />
            <path id="XMLID_9359_" d="M157.2,23.3c-.1.1-.3.2-.4.3Z" fill="#fff" />
            <path
              id="XMLID_9357_"
              d="M157.2,23.3,167.9,34h-.6L156.9,23.6C156.9,23.4,157,23.4,157.2,23.3Z"
              fill="#fff"
            />
            <path id="XMLID_9356_" d="M155.7,24.5a1.38,1.38,0,0,0-.3.4Z" fill="#fff" />
            <path id="XMLID_9354_" d="M155.7,24.5l9.5,9.5h-.7l-9.2-9.2A1.38,1.38,0,0,0,155.7,24.5Z" fill="#fff" />
            <path id="XMLID_9352_" d="M152.5,23.9a5.071,5.071,0,0,0-1.6-.9Z" fill="#fff" />
            <path id="XMLID_9351_" d="M152.5,23.9,162.6,34h-.7l-11-11A8.272,8.272,0,0,1,152.5,23.9Z" fill="#fff" />
            <path id="XMLID_9349_" d="M148.2,22.2c-.2,0-.5-.1-.7-.1Z" fill="#fff" />
            <path id="XMLID_9348_" d="M148.2,22.2,160,34h-.7L147.4,22.1A2.2,2.2,0,0,1,148.2,22.2Z" fill="#fff" />
            <path id="XMLID_9347_" d="M145.6,22.2c-.2,0-.4.1-.6.1Z" fill="#fff" />
            <path id="XMLID_9345_" d="M145.6,22.2,157.4,34h-.7L145,22.3A1.268,1.268,0,0,1,145.6,22.2Z" fill="#fff" />
            <path id="XMLID_9344_" d="M143.4,22.7c-.2.1-.3.1-.5.2Z" fill="#fff" />
            <path
              id="XMLID_9342_"
              d="M143.4,22.7,154.7,34H154L143,22.9C143.1,22.8,143.3,22.8,143.4,22.7Z"
              fill="#fff"
            />
            <path id="XMLID_9341_" d="M141.7,23.6c-.1.1-.3.2-.4.3Z" fill="#fff" />
            <path
              id="XMLID_9339_"
              d="M141.7,23.6,152.1,34h-.7L141.2,23.8C141.4,23.7,141.5,23.6,141.7,23.6Z"
              fill="#fff"
            />
            <path id="XMLID_9338_" d="M140.2,24.7l-.3.3Z" fill="#fff" />
            <path id="XMLID_9336_" d="M140.2,24.7l9.3,9.3h-.7l-8.9-8.9C139.9,24.9,140.1,24.8,140.2,24.7Z" fill="#fff" />
            <path id="XMLID_9333_" d="M138.9,26.1c-.1.1-.2.3-.3.4Z" fill="#fff" />
            <path id="XMLID_9332_" d="M138.9,26.1l7.9,7.9h-.7l-7.5-7.5A1.381,1.381,0,0,1,138.9,26.1Z" fill="#fff" />
            <path id="XMLID_9331_" d="M138,27.7c-.1.2-.1.3-.2.5Z" fill="#fff" />
            <path id="XMLID_9329_" d="M138,27.7l6.2,6.2h-.7l-5.8-5.8A1.381,1.381,0,0,0,138,27.7Z" fill="#fff" />
            <path id="XMLID_9327_" d="M137.3,29.7c0,.2-.1.4-.1.6Z" fill="#fff" />
            <path id="XMLID_9326_" d="M137.3,29.7l4.3,4.3h-.7l-3.7-3.7A1.268,1.268,0,0,1,137.3,29.7Z" fill="#fff" />
            <path id="XMLID_9325_" d="M137,32.1v0Z" fill="#fff" />
            <path id="XMLID_9323_" d="M137,32.1l1.9,1.9h-.7L137,32.8Z" fill="#fff" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default IllustrationSagaSvg;
